/* eslint-disable */
import React from 'react'
import {Checkbox, Icon, message, Pagination, Radio} from 'antd'
import $ from 'jquery'

import {Button, Modal, ModalBody, ModalFooter, ModalHeader} from 'mdbreact'
import http from '../../Component/Interceptor/Interseptor'
import moment from 'moment'
import jMoment from 'moment-jalaali'
import {DatePicker, MuiPickersUtilsProvider} from 'material-ui-pickers'
import JalaliUtils from 'material-ui-pickers-jalali-utils'
import {Link} from 'react-router-dom'
import REPORT_RETAIL from '../../Component/BaseComponent/REPORTRETAIL'
import WAREHOUSE from '../BaseComponent/WAREHOUSE'
import SearchableCombo from '../BaseComponent/searchableCombo'
import InputMask from 'react-input-mask'
import Select from 'react-select'
import {CopyToClipboard} from 'react-copy-to-clipboard'
import JASPERREPORT from '../BaseComponent/JASPERREPORT'
import {Helmet} from 'react-helmet'
import Loader from '../loaders/loader'
import {productShop} from '../../lib/path'
import AutoComplete from '../BaseComponent/autocomplete'
import ParcelSearch from '../BaseComponent/parcelSearch'
jMoment.loadPersian({dialect: 'persian-modern', usePersianDigits: true})
const RadioGroup = Radio.Group

class AddPreRecord extends React.Component {
  constructor(props) {
    super(props)

    this.confirmBtn = React.createRef()

    this.state = {
      beepUrl: '/beep-06.mp3',
      wrongUrl: '/erro.mp3',
      parcelId: '',
      typePrimaryId: '',
      lastEnteredProduct: {
        name: '',
        barcode: '',
        time: '',
        count: '',
        unit: ''
      },
      otherSellers: false,
      clipBoardStr: '',
      testData: '',
      manualRegVal: moment(),
      selectedOption: null,
      providerValue: '',
      providers: [],
      refFactorVal: null,
      typeWarehouseId: '',
      typeDocId: '',
      isInput: '',
      refType: '',

      isInternal: false,
      abnormal: false,
      refWarehouseId: '',
      id: '',
      code: '',
      quantity: '',
      product: [],
      details: [],
      wareHousesname: [],
      docType: [],
      errorDocForm: '',
      addError: '',
      valueBarcode: 'barcodeOnly',
      fadeTable: 'true',
      visible: false,
      searchesProduct: [],
      search: '',
      searchTablevisibility: false,
      pageNumber: 1,
      lengthProducts: 0,
      docNum: '',
      modal: false,
      manualRegisterDate: '',
      errorForm: {
        warehouseName: '',
        isInputError: '',
        warehouseTypeError: ''
      },
      docArr: [],
      refFactor: null,
      providerId: '',
      refFactorNo: '',
      modalConfirm: false,
      modalError: false,
      unMatchProduct: [],
      errorCountText: '',
      checkIsInput: '',
      textUnMatch: '',
      tableNotFound: false,
      tableNotRemain: false,
      incompatibleRemainProducts: [],
      incompatibleSupplyOrderProducts: [],
      incompatibleDispatchProducts: [],
      anbarType: '',
      anbarTypeTaraf: '',
      warehouseId: '',
      typewarehouseId: '',
      typeRefWarehouseId: '',
      providerIdSearch: null,
      clipBoardText: '',
      deliveryDates: [],
      loading: false,
      init: true,
      sendRequest: true
    }
  }

  handleChangeSearchable = (selectedOption) => {
    this.setState({selectedOption})
    this.setState({
      providerValue: selectedOption.value
    })
    console.log(`Option selected:`, selectedOption)
  }

  handleDateChangeManual = (date) => {
    let urlParams = new URLSearchParams(window.location.search)
    let preRecordId = urlParams.get('id') === null ? '' : urlParams.get('id')
    let ls = JSON.parse(localStorage.getItem('objectAddPreRecord' + preRecordId))
    ls['manualRegVal'] = date
    localStorage.setItem('objectAddPreRecord' + preRecordId, JSON.stringify(ls))
    this.setState({manualRegVal: date})
  }

  preventType = (e) => {
    e.preventDefault()
  }

  handleDaterefFactor = (date) => {
    let urlParams = new URLSearchParams(window.location.search)
    let preRecordId = urlParams.get('id') === null ? '' : urlParams.get('id')
    let ls = JSON.parse(localStorage.getItem('objectAddPreRecord' + preRecordId))
    ls['refFactor'] = date
    localStorage.setItem('objectAddPreRecord' + preRecordId, JSON.stringify(ls))
    this.setState({refFactor: date})
  }

  componentWillUnmount() {
    let data = {
      typeWarehouseId: '',
      checkIsInput: '',
      typeDocId: '',
      isInternal: false,
      abnormal: false,
      otherSellers: false,
      senderName: '',
      receiverName: '',
      refFactorNo: '',
      description: '',
      manualRegVal: moment(),
      refFactor: null,
      refWarehouseId: '',
      providerId: '',
      product: [],
      details: []
    }
    let urlParams = new URLSearchParams(window.location.search)
    let preRecordId = urlParams.get('id') === null ? '' : urlParams.get('id')
    localStorage.removeItem('objectAddPreRecord' + preRecordId)
  }

  componentDidMount() {
    let urlParams = new URLSearchParams(window.location.search)
    let preRecordId = urlParams.get('id') === null ? '' : urlParams.get('id')
    if (localStorage.getItem('objectAddPreRecord' + preRecordId) !== null) {
      let ls = JSON.parse(localStorage.getItem('objectAddPreRecord' + preRecordId))
      if (ls.checkIsInput !== '') {
        this.filterDocIds(ls.checkIsInput)
      }
      if (ls.typeWarehouseId !== '' || ls.typeWarehouseId !== 0) {
        this.getListOfProviders(ls.typeWarehouseId)
      }
      this.setState({
        typeWarehouseId: ls.typeWarehouseId,
        checkIsInput: ls.checkIsInput,
        typeDocId: ls.typeDocId,
        isInternal: ls.isInternal,
        abnormal: ls.abnormal,
        senderName: ls.senderName,
        receiverName: ls.receiverName,
        refFactorNo: ls.refFactorNo,
        description: ls.description,
        manualRegVal: ls.manualRegVal,
        refFactor: ls.refFactor,
        refWarehouseId: ls.refWarehouseId,
        anbarTypeTaraf: ls.anbarTypeTaraf,
        anbarType: ls.anbarType,
        product: ls.product,
        details: ls.details,
        otherSellers: ls.otherSellers,
        refType: ls.refType,
        providerId: ls.providerId,
        providerIdSearch: ls.providerId,
        parcelId: ls.parcelId,
        init: false
      })
    } else {
      let data = {
        typeWarehouseId: '',
        checkIsInput: '',
        typeDocId: '',
        isInternal: false,
        abnormal: false,
        otherSellers: false,
        senderName: '',
        receiverName: '',
        refFactorNo: '',
        description: '',
        manualRegVal: moment(),
        refFactor: null,
        refWarehouseId: '',
        providerId: '',
        providerIdSearch: '',
        product: [],
        details: [],
        anbarTypeTaraf: '',
        anbarType: '',
        refType: '',
        init: false,
        parcelId: ''
      }
      this.setState({
        init: false
      })
      localStorage.setItem('objectAddPreRecord' + preRecordId, JSON.stringify(data))
    }

    const token = sessionStorage.getItem('accessToken')

    http
      .get(`${WAREHOUSE.WAREHOUSE_TYPE_LIST_WAREHOUSE}`, {})
      .then((response) => {
        var result = response.data.object
        for (let i = 0; i < result.length; i++) {
          result[i]['value'] = result[i].id
          result[i]['label'] = result[i].name + ' - ' + result[i].typePrimaryName
        }
        this.setState(
          {
            wareHousesname: response.data.object
          },
          () => {
            let urlParams = new URLSearchParams(window.location.search)
            let preRecordId = urlParams.get('id') === null ? '' : urlParams.get('id')
            let ls = JSON.parse(localStorage.getItem('objectAddPreRecord' + preRecordId))
            if (ls.typeWarehouseId !== '') {
              let catchedTypeWarehouseId = ls.typeWarehouseId
              let findSelectedWarehouseId = this.state.wareHousesname.find((item) => item.id === catchedTypeWarehouseId)
              if (findSelectedWarehouseId) {
                this.setState({
                  warehouseId: findSelectedWarehouseId
                })
              }
            }
            if (ls.refWarehouseId !== '') {
              let catchedRefWarehouseId = ls.refWarehouseId
              let findSelectedRefWarehouseId = this.state.wareHousesname.find(
                (item) => item.id === catchedRefWarehouseId
              )
              if (findSelectedRefWarehouseId) {
                this.setState({
                  typeRefWarehouseId: findSelectedRefWarehouseId
                })
              }
            }
          }
        )
      })
      .catch((error) => {
        console.log(error)
      })
  }

  submitForm(e) {
    e.preventDefault()
  }

  onChange = (e) => {
    console.log('radio checked', e.target.isInput)
    this.setState({
      isInput: e.target.value
    })
  }

  changeWareHouseId = (warehouseId) => {
    console.log(warehouseId)
    this.setState(
      {
        warehouseId,
        providerId: '',
        typePrimaryId: warehouseId ? warehouseId.typePrimaryId : ''
      },
      () => {
        const value = warehouseId === null ? '' : warehouseId.id
        const anbarType = warehouseId === null ? '' : warehouseId.typePrimaryId
        let urlParams = new URLSearchParams(window.location.search)
        let preRecordId = urlParams.get('id') === null ? '' : urlParams.get('id')
        let ls = JSON.parse(localStorage.getItem('objectAddPreRecord' + preRecordId))
        ls['typeWarehouseId'] = value === '' ? '' : +value
        localStorage.setItem('objectAddPreRecord' + preRecordId, JSON.stringify(ls))
        this.setState(
          {
            typeWarehouseId: value,
            anbarType: anbarType === '' ? '' : anbarType
          },
          () => {
            let ls = JSON.parse(localStorage.getItem('objectAddPreRecord' + preRecordId))
            ls['anbarType'] = anbarType === '' ? '' : anbarType
            localStorage.setItem('objectAddPreRecord' + preRecordId, JSON.stringify(ls))
          }
        )
        if (value !== '') {
          this.getListOfProviders(value)
        }
      }
    )
    // const target = e.target;
    // const value =target.value;
    // const anbarType = target.options[target.selectedIndex].getAttribute('data-anbarType');
    // let urlParams = new URLSearchParams(window.location.search)
    // let preRecordId = urlParams.get('id') === null ? '' : urlParams.get('id')
    // let ls = JSON.parse(localStorage.getItem('objectAddPreRecord' + preRecordId))
    // ls['typeWarehouseId'] = +value
    // localStorage.setItem('objectAddPreRecord' + preRecordId, JSON.stringify(ls))
    // this.setState({
    //     typeWarehouseId: value,
    //     anbarType: anbarType === null ? '' : anbarType
    // }, () => {
    //     let ls = JSON.parse(localStorage.getItem('objectAddPreRecord' + preRecordId))
    //     ls['anbarType'] = anbarType === null ? '' : anbarType
    //     localStorage.setItem('objectAddPreRecord' + preRecordId, JSON.stringify(ls))
    // })

    // this.getListOfProviders(value)
  }

  changeTypeWareHouseId = (typeRefWarehouseId) => {
    this.setState(
      {
        typeRefWarehouseId
      },
      () => {
        const value = typeRefWarehouseId === null ? '' : typeRefWarehouseId.id
        const anbarTypeTaraf = typeRefWarehouseId === null ? '' : typeRefWarehouseId.typePrimaryId
        let urlParams = new URLSearchParams(window.location.search)
        let preRecordId = urlParams.get('id') === null ? '' : urlParams.get('id')
        let ls = JSON.parse(localStorage.getItem('objectAddPreRecord' + preRecordId))
        ls['refWarehouseId'] = value === '' ? '' : +value
        localStorage.setItem('objectAddPreRecord' + preRecordId, JSON.stringify(ls))
        this.setState(
          {
            refWarehouseId: value,
            anbarTypeTaraf: anbarTypeTaraf === '' ? '' : anbarTypeTaraf
          },
          () => {
            let ls = JSON.parse(localStorage.getItem('objectAddPreRecord' + preRecordId))
            ls['anbarTypeTaraf'] = anbarTypeTaraf === '' ? '' : anbarTypeTaraf
            localStorage.setItem('objectAddPreRecord' + preRecordId, JSON.stringify(ls))
          }
        )
      }
    )
  }

  getListOfProviders = (wareHouseId) => {
    // this.setState({
    //     providerId: null
    // })
    // http.get(`${REPORT_RETAIL.REPORT_RETAIL_LIST_PROVIDER}?typeWarehouseId=${wareHouseId}`, {}).then((response) => {
    //     if (response.data.error == null) {
    //         var result = response.data.object;
    //         for (let i = 0; i < result.length; i++) {
    //             result[i]['value'] = result[i].providerId;
    //             result[i]['label'] =result[i].providerId +' - '+ result[i].title;
    //         }
    //         this.setState({
    //             providers: response.data.object
    //         }, () => {
    //             let urlParams = new URLSearchParams(window.location.search)
    //             let preRecordId = urlParams.get('id') === null ? '' : urlParams.get('id')
    //             let ls = JSON.parse(localStorage.getItem('objectAddPreRecord' + preRecordId))
    //             if (ls.providerId !== '') {
    //                 let catchedProviderId = ls.providerId
    //                 let findSelectedProviderId = this.state.providers.find(item => item.providerId === catchedProviderId)
    //                 if (findSelectedProviderId) {
    //                     this.setState({
    //                         providerId: findSelectedProviderId,
    //                         providerIdSearch: findSelectedProviderId,
    //                     })
    //                 }
    //             }
    //         })
    //     }
    //     else{
    //         // message.error(response.data.description)
    //         this.setState({
    //             providers: []
    //         })
    //     }
    //     // alert(JSON.stringify(response.data))
    // }).catch((error) => {
    //     alert(JSON.stringify(error))
    // });
  }

  getValueProvider = (providerId) => {
    let urlParams = new URLSearchParams(window.location.search)
    let preRecordId = urlParams.get('id') === null ? '' : urlParams.get('id')
    let ls = JSON.parse(localStorage.getItem('objectAddPreRecord' + preRecordId))
    if (providerId === null) {
      ls['providerId'] = ''
      localStorage.setItem('objectAddPreRecord' + preRecordId, JSON.stringify(ls))
    } else {
      ls['providerId'] = providerId
      localStorage.setItem('objectAddPreRecord' + preRecordId, JSON.stringify(ls))
    }
    this.setState({
      providerId,
      providerIdSearch: providerId
    })
  }

  changeField(e) {
    const target = e.target
    const value = target.type == 'checkbox' ? target.checked : target.value
    const name = target.name
    if (name === 'isInternal') {
      this.setState({
        refType: ''
      })
    }
    let urlParams = new URLSearchParams(window.location.search)
    let preRecordId = urlParams.get('id') === null ? '' : urlParams.get('id')
    let ls = JSON.parse(localStorage.getItem('objectAddPreRecord' + preRecordId))
    ls[name] = value
    localStorage.setItem('objectAddPreRecord' + preRecordId, JSON.stringify(ls))
    this.setState({
      [name]: value,
      id: value
    })
    if (name === 'refWarehouseId') {
      const anbarTypeTaraf = target.options[target.selectedIndex].getAttribute('data-anbarTypeTaraf')

      this.setState(
        {
          anbarTypeTaraf
        },
        () => {
          let urlParams = new URLSearchParams(window.location.search)
          let preRecordId = urlParams.get('id') === null ? '' : urlParams.get('id')
          let ls = JSON.parse(localStorage.getItem('objectAddPreRecord' + preRecordId))
          ls['anbarTypeTaraf'] = this.state.anbarTypeTaraf
          localStorage.setItem('objectAddPreRecord' + preRecordId, JSON.stringify(ls))
        }
      )
    }
  }

  onChangeRadio = (e) => {
    console.log('radio checked', e.target.value)
    this.setState({
      valueBarcode: e.target.value
    })
  }

  onchangeSearch(e) {
    this.setState({
      search: e.target.value
    })
  }

  showModal = () => {
    this.setState({
      visible: true
    })
  }

  toggle = () => {
    this.setState({
      modal: !this.state.modal,
      searchesProduct: [],
      searchTablevisibility: false,
      showProviderModal: false
    })
  }

  openModal = () => {
    this.setState(
      {
        providerIdSearch: this.state.provider,
        modal: !this.state.modal
      },
      () => {
        this.setState({
          showProviderModal: true
        })
      }
    )
  }

  onChangePagination(pageNumber) {
    this.setState({
      pageNumber: pageNumber
    })
    // console.log('Page: ', pageNumber);

    let productName = document.getElementById('productName').value
    let providerId = this.state.providerIdSearch
    let articleCode = document.getElementById('articleCode').value
    let productCode = document.getElementById('productCode').value
    http
      .get(
        `${
          REPORT_RETAIL.REPORT_RETAIL_PRODUCT
        }?export=false&productName=${productName}&articleId=${articleCode}&productCode=${productCode}&providerId=${providerId}&typeWarehouseId=${
          this.state.typeWarehouseId
        }&pageSize=7&pageNumber=${pageNumber}`,
        {}
      )
      .then((response) => {
        if (response.data.error == null) {
          let data = response.data.object.result
          for (let i = 0; i < data.length; i++) {
            if (data[i]['productUnitTitle'] == 'عدد') {
              data[i]['vahed'] = 'sahih'
            } else {
              data[i]['vahed'] = 'ashar'
            }
          }

          this.setState({
            searchesProduct: response.data.object.result,
            searchTablevisibility: true,
            lengthProducts: response.data.object.countAll
          })
        } else {
          message.error(response.data.description)
        }

        // alert(response.data.object.countAll)
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })
  }

  searchProduct(e) {
    let productName = document.getElementById('productName').value
    // document.getElementById('productName').focus();
    let providerId = this.state.providerIdSearch ? this.state.providerIdSearch : ''
    let articleCode = document.getElementById('articleCode').value
    let productCode = document.getElementById('productCode').value
    if (this.state.typeWarehouseId == '') {
      message.error('انبار انتخاب شود')
    } else if (productName == '' && providerId == '' && articleCode == '' && productCode == '') {
      message.error('حداقل یک فیلتر وارد شود')
    } else {
      // if(productCode.length=='13' && !(productCode[0]=='6')){
      //     var extractBarcode=productCode.substring(1,7)
      //     productCode=extractBarcode;
      //     var extractWeight=productCode.substring(7,12)
      // }
      // else{
      //     productCode=productCode;
      // }

      http
        .get(
          `${
            REPORT_RETAIL.REPORT_RETAIL_PRODUCT
          }?export=false&productName=${productName}&providerId=${providerId}&articleId=${articleCode}&productCode=${productCode}&typeWarehouseId=${
            this.state.typeWarehouseId
          }&pageSize=7&pageNumber=1`,
          {}
        )
        .then((response) => {
          if (response.data.error == null) {
            this.setState({
              pageNumber: 1
            })

            let data = response.data.object.result
            for (let i = 0; i < data.length; i++) {
              if (data[i]['productUnitTitle'] == 'کیلو گرم' || data[i]['productUnitTitle'] == 'لیتر') {
                data[i]['vahed'] = 'ashar'
              } else {
                data[i]['vahed'] = 'sahih'
              }
            }

            this.setState({
              searchesProduct: response.data.object.result,
              searchTablevisibility: true,
              lengthProducts: response.data.object.countAll
            })
          } else {
            this.setState({
              searchesProduct: [],
              searchTablevisibility: false
            })
            message.error(response.data.description)
          }

          // alert(response.data)
        })
        .catch((error) => {
          alert('error is' + JSON.stringify(error))
        })
    }
  }

  handleOk = (e) => {
    let {search} = this.state
    let productObject = this.state.searchesProduct[search]
    if (productObject == undefined) {
      message.error('محصول مورد نظر را انتخاب کنید سپس تایید کنید')
    } else {
      this.quantity.focus()
      this.barcode.value = this.barcode.value = productObject['productCode']

      this.setState({
        modal: !this.state.modal,
        searchesProduct: [],
        searchTablevisibility: false
      })

      //
      // let details = {
      //     id: productObject['stockProductId']
      //     ,
      //     quantity: 1
      // };
      // let detailsArray = [];
      // detailsArray.push(details);
      // let findDetails = this.state.details.find(detailsArray => detailsArray.id == details.id);
      // if (!findDetails) {
      //     this.setState((prevState) => ({
      //         details: [...prevState.details, details]
      //     }))
      // }
      // let array = [];
      // array.push(productObject);
      // productObject['quantity'] = 1;
      // let isFound = this.state.product.find(product => product.articleId == productObject.articleId);
      //
      // if (!isFound) {
      //
      //
      //     this.setState((prevState) => ({
      //         product: [...prevState.product, productObject],
      //         fadeTable: 'false'
      //         ,
      //         id: ''
      //         ,
      //         search: ''
      //     }))
      //
      // } else {
      //     var index = this.state.product.findIndex(product => product.articleId == productObject.articleId);
      //     if (index >= 0) {
      //         this.barcode.focus();
      //         this.setState((prevState) => {
      //             const newProduct = this.state.product;
      //             newProduct[index].quantity = Number(newProduct[index].quantity) + Number(productObject['quantity']);
      //             return {
      //                 product: newProduct
      //             }
      //         })
      //     }
      // }
      // this.setState({
      //     modal: !this.state.modal
      // });
      // console.log(e);
      // this.setState({
      //     visible: false,
      //     searchTablevisibility: false,
      //     searchesProduct: []
      // });
    }
  }

  handleCancel = (e) => {
    console.log(e)
    this.setState({
      visible: false,
      searchTablevisibility: false,
      searchesProduct: []
    })

    this.setState({
      modal: !this.state.modal
    })
  }

  optionalFields(e) {
    const target = e.target
    const value = target.value
    const name = target.name
    let urlParams = new URLSearchParams(window.location.search)
    let preRecordId = urlParams.get('id') === null ? '' : urlParams.get('id')
    let ls = JSON.parse(localStorage.getItem('objectAddPreRecord' + preRecordId))
    ls[name] = value
    localStorage.setItem('objectAddPreRecord' + preRecordId, JSON.stringify(ls))

    if (!(value == '')) {
      this.setState({
        [name]: value
      })
    } else {
      this.setState({
        [name]: ''
      })
    }
  }

  barcodeChange(e) {
    const target = e.target
    const value = target.value

    const name = target.name
    const valueRadio = this.state.valueBarcode

    if (
      valueRadio == 'barcodeCount' &&
      e.key == 'Enter' &&
      (document.getElementById('id').value.length == '13' && document.getElementById('id').value[0] != '6')
    ) {
      e.preventDefault()

      //alert('hi')
      document.getElementById('quantity').value = ''

      document.getElementById('quantity').select()
    } else if (valueRadio == 'barcodeCount' && e.key == 'Enter' && document.getElementById('id').value.length == '16') {
      e.preventDefault()
      message.error('لطفا در حالت بارکد کار کنید')
      document.getElementById('id').select()
    } else if (valueRadio == 'barcodeCount' && e.key == 'Enter' && document.getElementById('id').value.length == '18') {
      e.preventDefault()
      message.error('لطفا در حالت بارکد کار کنید')
      document.getElementById('id').select()
    } else if (valueRadio == 'barcodeCount' && e.key == 'Enter' && document.getElementById('id').value.length != '13') {
      e.preventDefault()

      //alert('hi')
      document.getElementById('quantity').value = ''

      document.getElementById('quantity').select()
    } else if (
      valueRadio == 'barcodeCount' &&
      e.key == 'Enter' &&
      (document.getElementById('id').value.length == '13' && document.getElementById('id').value[0] == '6')
    ) {
      e.preventDefault()

      //alert('hi')
      document.getElementById('quantity').value = ''

      document.getElementById('quantity').select()
    }
  }

  createProductObject = (id, quantity, response) => {
    var decimalDobule = 3

    let details = {
      id: id,
      quantity: quantity,
      manufactureDate: ''
    }
    let {lastEnteredProduct} = this.state
    lastEnteredProduct.count = quantity
    this.setState({
      lastEnteredProduct
    })
    let detailsArray = []
    detailsArray.push(details)
    let findDetails = this.state.details.find((detailsArray) => detailsArray.id == details.id)
    if (!findDetails) {
      this.setState(
        (prevState) => ({
          details: [...prevState.details, details]
        }),
        () => {
          let urlParams = new URLSearchParams(window.location.search)
          let preRecordId = urlParams.get('id') === null ? '' : urlParams.get('id')
          let ls = JSON.parse(localStorage.getItem('objectAddPreRecord' + preRecordId))
          ls['details'] = this.state.details
          localStorage.setItem('objectAddPreRecord' + preRecordId, JSON.stringify(ls))
        }
      )
    } else {
      let urlParams = new URLSearchParams(window.location.search)
      let preRecordId = urlParams.get('id') === null ? '' : urlParams.get('id')
      findDetails.quantity = (Number(findDetails.quantity) + Number(quantity))
        .toFixed(decimalDobule)
        .replace(/.000/g, '')
      let ls = JSON.parse(localStorage.getItem('objectAddPreRecord' + preRecordId))
      ls['details'] = this.state.details
      localStorage.setItem('objectAddPreRecord' + preRecordId, JSON.stringify(ls))
    }
    let array = []
    array.unshift(response)
    let isFound = this.state.product.find((product) => product.articleId == response.articleId)

    if (!isFound) {
      this.barcode.focus()
      this.setState(
        (prevState) => ({
          product: [response, ...prevState.product],
          fadeTable: 'false',
          id: ''
        }),
        () => {
          let urlParams = new URLSearchParams(window.location.search)
          let preRecordId = urlParams.get('id') === null ? '' : urlParams.get('id')
          let ls = JSON.parse(localStorage.getItem('objectAddPreRecord' + preRecordId))
          ls['product'] = this.state.product
          localStorage.setItem('objectAddPreRecord' + preRecordId, JSON.stringify(ls))
        }
      )
      // this.setState({
      //     product:this.state.product
      // })
    } else {
      var index = this.state.product.findIndex((product) => product.articleId == response.articleId)
      if (index >= 0) {
        this.barcode.focus()
        this.setState(
          (prevState) => {
            const newProduct = this.state.product
            newProduct[index].quantity = (Number(newProduct[index].quantity) + Number(quantity))
              .toFixed(decimalDobule)
              .replace(/.000/g, '')
            return {
              product: newProduct
            }
          },
          () => {
            let urlParams = new URLSearchParams(window.location.search)
            let preRecordId = urlParams.get('id') === null ? '' : urlParams.get('id')
            let ls = JSON.parse(localStorage.getItem('objectAddPreRecord' + preRecordId))
            ls['product'] = this.state.product
            localStorage.setItem('objectAddPreRecord' + preRecordId, JSON.stringify(ls))
          }
        )
      }
    }
  }

  changeQuantity(e) {
    const target = e.target
    const value = target.value
    const name = target.name
  }

  addDialogLastProduct = (res) => {
    this.setState(
      {
        sendRequest: false,
        lastEnteredProduct: {
          name: res.data.object.productName,
          barcode: res.data.object.productCode,
          time: jMoment().format('HH:mm'),
          count: '',
          unit: res.data.object.productUnitTitle
        },
        showLastProduct: true,
        addProduct: true,
        removeProduct: false
      },
      () => {
        setTimeout(() => {
          this.setState(
            {
              sendRequest: true
            },
            () => {}
          )
        }, 10)
      }
    )
  }
  toEnDigit(s) {
    return s.replace(/[\u0660-\u0669\u06f0-\u06f9]/g,    // Detect all Persian/Arabic Digit in range of their Unicode with a global RegEx character set
        function(a) { return a.charCodeAt(0) & 0xf }     // Remove the Unicode base(2) range that not match
    )
  }
  addProduct() {
    console.log(this.state.sendRequest)
    if (this.state.sendRequest) {
      this.setState({
        sendRequest: false
      })
      const valueRadio = this.state.valueBarcode
      let id = document.getElementById('id').value.trim()
      id = this.toEnDigit(id)
      var extractId = ''
      let quantity = document.getElementById('quantity').value

      if (id == '') {
        this.setState({
          addError: 'یک محصول وارد کنید',
          sendRequest: true
        })
      } else if (
        this.state.valueBarcode == 'barcodeCount' &&
        quantity == '' &&
        document.getElementById('id').value.trim().length == '13'
      ) {
        this.setState({
          addError: 'تعداد محصول وارد کنید',
          sendRequest: true
        })
      } else if (
        this.state.valueBarcode == 'barcodeCount' &&
        quantity == '' &&
        document.getElementById('id').value.trim().length == '16'
      ) {
        message.error('لطفا در حالت بارکد کار کنید')
      } else if (
        this.state.valueBarcode == 'barcodeCount' &&
        quantity == '' &&
        document.getElementById('id').value.trim().length == '18'
      ) {
        message.error('لطفا در حالت بارکد کار کنید')
      } else if (
        this.state.valueBarcode == 'barcodeCount' &&
        quantity != '' &&
        document.getElementById('id').value.trim().length == '16'
      ) {
        message.error('لطفا در حالت بارکد کار کنید')
      } else if (
        this.state.valueBarcode == 'barcodeCount' &&
        quantity != '' &&
        document.getElementById('id').value.trim().length == '18'
      ) {
        message.error('لطفا در حالت بارکد کار کنید')
      } else if (this.state.valueBarcode == 'barcodeCount' && quantity.match(/[a-z A-Z]/g)) {
        this.setState({
          addError: 'تعداد محصول باید عددی باشد'
        })
      } else if (this.state.valueBarcode == 'barcodeCount' && quantity.match(/[a-z A-Z آ-ی]/g)) {
        this.setState({
          addError: 'تعداد محصول باید عددی باشد'
        })
      } else if (this.state.valueBarcode == 'barcodeCount' && quantity.match(/[!@#$%^&*()\-+,?":{}=|<>/]/g)) {
        this.setState({
          addError: 'تعداد محصول باید عددی باشد'
        })
      } else {
        // if(id.length=='13' && !(id[0]=='6')){
        //     var extractBarcode=id.substring(1,7)
        //     id=extractBarcode;
        //     alert(id)
        //     var extractWeight=id.substring(7,12)
        // }
        if (id.length == '16') {
          var extractBarcode = id.substring(5, 11)
          var extractWeight = id.substring(11, 16)
          extractId = extractBarcode
        } else if (id.length == '18') {
          var extractBarcode = id.substring(7, 13)
          var extractWeight = id.substring(13, 18)
          extractId = extractBarcode
        } else {
          extractId = id
        }

        http
          .get(`${REPORT_RETAIL.REPORT_RETAIL_GET_PRODUCTBYCODE}?code=${extractId}`, {})
          .then((response) => {
            if (response.data.error == null) {
              var idValue = document.getElementById('id').value.trim()

              let data = response.data.object

              data.manufactureDate = ''
              if (data.productUnitTitle == 'کیلو گرم' || data.productUnitTitle == 'لیتر') {
                data.vahed = 'ashar'
              } else {
                data.vahed = 'sahih'
              }

              this.setState({
                sendRequest: true,
                addError: ''
              })

              var productObject = response.data.object
              var proId = response.data.object.providerId
              var stateProviderId = this.state.providerId

              if (data.productUnitTitle == 'کیلو گرم' || data.productUnitTitle == 'لیتر') {
                if (valueRadio == 'barcodeOnly' && idValue.length == '16') {
                  $('#id').select()
                  $('#id').val('')
                  $('#quantity').val('')

                  var temp = this.toEnDigit(idValue)
                  var extractWeight = temp.substring(11, 16)
                  productObject['quantity'] = Number(extractWeight / 1000)
                  idValue = ''
                  document.getElementById('quantity').value = ''

                  if (stateProviderId != '' && proId == stateProviderId) {
                    let url = this.state.beepUrl
                    let audio = new Audio(url)
                    audio.play()
                    this.addDialogLastProduct(response)
                    this.createProductObject(productObject['stockProductId'], productObject['quantity'], productObject)
                  } else if (!stateProviderId) {
                    let url = this.state.beepUrl
                    let audio = new Audio(url)
                    audio.play()
                    this.addDialogLastProduct(response)
                    this.createProductObject(productObject['stockProductId'], productObject['quantity'], productObject)
                  } else {
                    let url = this.state.wrongUrl
                    let audio = new Audio(url)
                    audio.play()
                    $('#id').select()
                    $('#id').val('')
                    $('#quantity').val('')
                    message.error('این کالا مربوط به این تامین کننده نیست')
                  }
                } else if (valueRadio == 'barcodeOnly' && idValue.length == '18') {
                  $('#id').select()
                  $('#id').val('')
                  $('#quantity').val('')

                  var temp = this.toEnDigit(idValue)
                  var extractWeight = temp.substring(13, 18)
                  productObject['quantity'] = Number(extractWeight / 1000)
                  idValue = ''
                  document.getElementById('quantity').value = ''
                  if (stateProviderId != '' && proId == stateProviderId) {
                    let url = this.state.beepUrl
                    let audio = new Audio(url)
                    audio.play()
                    this.addDialogLastProduct(response)
                    this.createProductObject(productObject['stockProductId'], productObject['quantity'], productObject)
                  } else if (!stateProviderId) {
                    let url = this.state.beepUrl
                    let audio = new Audio(url)
                    audio.play()
                    this.addDialogLastProduct(response)
                    this.createProductObject(productObject['stockProductId'], productObject['quantity'], productObject)
                  } else {
                    let url = this.state.wrongUrl
                    let audio = new Audio(url)
                    audio.play()
                    $('#id').select()
                    $('#id').val('')
                    $('#quantity').val('')
                    message.error('این کالا مربوط به این تامین کننده نیست')
                  }
                } else if (valueRadio == 'barcodeCount' && idValue.length == '16') {
                  $('#id').select()
                  $('#id').val('')
                  $('#quantity').val('')

                  var temp = this.toEnDigit(idValue)
                  var extractWeight = temp.substring(11, 16)
                  productObject['quantity'] = Number(extractWeight / 1000)
                  idValue = ''
                  document.getElementById('quantity').value = ''

                  if (stateProviderId != '' && proId == stateProviderId) {
                    let url = this.state.beepUrl
                    let audio = new Audio(url)
                    audio.play()
                    this.addDialogLastProduct(response)
                    this.createProductObject(productObject['stockProductId'], productObject['quantity'], productObject)
                  } else if (!stateProviderId) {
                    let url = this.state.beepUrl
                    let audio = new Audio(url)
                    audio.play()
                    this.addDialogLastProduct(response)
                    this.createProductObject(productObject['stockProductId'], productObject['quantity'], productObject)
                  } else {
                    let url = this.state.wrongUrl
                    let audio = new Audio(url)
                    audio.play()
                    $('#id').select()
                    $('#id').val('')
                    $('#quantity').val('')
                    message.error('این کالا مربوط به این تامین کننده نیست')
                  }
                } else if (valueRadio == 'barcodeCount' && idValue.length == '18') {
                  $('#id').select()
                  $('#id').val('')
                  $('#quantity').val('')

                  var temp = this.toEnDigit(idValue)
                  var extractWeight = temp.substring(13, 18)
                  productObject['quantity'] = Number(extractWeight / 1000)
                  idValue = ''
                  document.getElementById('quantity').value = ''

                  if (stateProviderId != '' && proId == stateProviderId) {
                    let url = this.state.beepUrl
                    let audio = new Audio(url)
                    audio.play()
                    this.addDialogLastProduct(response)
                    this.createProductObject(productObject['stockProductId'], productObject['quantity'], productObject)
                  } else if (!stateProviderId) {
                    let url = this.state.beepUrl
                    let audio = new Audio(url)
                    audio.play()
                    this.addDialogLastProduct(response)
                    this.createProductObject(productObject['stockProductId'], productObject['quantity'], productObject)
                  } else {
                    let url = this.state.wrongUrl
                    let audio = new Audio(url)
                    audio.play()
                    $('#id').select()
                    $('#id').val('')
                    $('#quantity').val('')
                    message.error('این کالا مربوط به این تامین کننده نیست')
                  }
                } else if (valueRadio == 'barcodeOnly' && (idValue.length != '16' && idValue.length != '18')) {
                  let url = this.state.wrongUrl
                  let audio = new Audio(url)
                  audio.play()
                  message.error('بارکد وارد شده برای یک محصول وزنی است.لطفا تعداد را وارد کنید')
                } else if (
                  valueRadio == 'barcodeCount' &&
                  quantity == '' &&
                  (idValue.length != '16' && idValue.length != '18')
                ) {
                  let url = this.state.wrongUrl
                  let audio = new Audio(url)
                  audio.play()
                  $('#quantity').select()
                  // $('#id').val('')
                  $('#quantity').val('')
                  message.error('بارکد وارد شده برای یک محصول وزنی است.لطفا تعداد را وارد کنید')

                  // productObject['quantity'] = quantity;
                  // this.createProductObject(productObject['stockProductId'],productObject['quantity'],productObject)
                } else if (
                  valueRadio == 'barcodeCount' &&
                  quantity != '' &&
                  (idValue.length != '16' && idValue.length != '18')
                ) {
                  // message.error('بارکد وارد شده برای یک محصول وزنی است.لطفا تعداد را وارد کنید')

                  $('#quantity').select()
                  $('#id').val('')
                  $('#quantity').val('')

                  productObject['quantity'] = quantity
                  if (stateProviderId != '' && proId == stateProviderId) {
                    let url = this.state.beepUrl
                    let audio = new Audio(url)
                    audio.play()
                    this.addDialogLastProduct(response)
                    this.createProductObject(productObject['stockProductId'], productObject['quantity'], productObject)
                  } else if (!stateProviderId) {
                    let url = this.state.beepUrl
                    let audio = new Audio(url)
                    audio.play()
                    this.addDialogLastProduct(response)
                    this.createProductObject(productObject['stockProductId'], productObject['quantity'], productObject)
                  } else {
                    let url = this.state.wrongUrl
                    let audio = new Audio(url)
                    audio.play()
                    $('#id').select()
                    $('#id').val('')
                    $('#quantity').val('')
                    message.error('این کالا مربوط به این تامین کننده نیست')
                  }
                } else if (valueRadio == 'barcodeOnly' && (idValue.length == '13' && idValue[0] != '6')) {
                  let url = this.state.wrongUrl
                  let audio = new Audio(url)
                  audio.play()
                  message.error('بارکد وارد شده برای یک محصول وزنی است.لطفا تعداد را وارد کنید')
                } else if (valueRadio == 'barcodeCount' && (idValue.length == '13' && idValue[0] != '6')) {
                  $('#quantity').select()
                  $('#id').val('')
                  $('#quantity').val('')

                  productObject['quantity'] = quantity
                  if (stateProviderId != '' && proId == stateProviderId) {
                    let url = this.state.beepUrl
                    let audio = new Audio(url)
                    audio.play()
                    this.addDialogLastProduct(response)
                    this.createProductObject(productObject['stockProductId'], productObject['quantity'], productObject)
                  } else if (!stateProviderId) {
                    let url = this.state.beepUrl
                    let audio = new Audio(url)
                    audio.play()
                    this.addDialogLastProduct(response)
                    this.createProductObject(productObject['stockProductId'], productObject['quantity'], productObject)
                  } else {
                    let url = this.state.wrongUrl
                    let audio = new Audio(url)
                    audio.play()
                    $('#id').select()
                    $('#id').val('')
                    $('#quantity').val('')
                    message.error('این کالا مربوط به این تامین کننده نیست')
                  }
                }
              } else {
                if (valueRadio == 'barcodeOnly' && idValue.length == '16') {
                  $('#quantity').select()
                  $('#id').val('')
                  $('#quantity').val('')

                  var temp = this.toEnDigit(idValue)
                  var extractWeight = temp.substring(11, 16)
                  productObject['quantity'] = Number(extractWeight / 1000)
                  idValue = ''
                  document.getElementById('quantity').value = ''

                  if (stateProviderId != '' && proId == stateProviderId) {
                    let url = this.state.beepUrl
                    let audio = new Audio(url)
                    audio.play()
                    this.addDialogLastProduct(response)
                    this.createProductObject(productObject['stockProductId'], productObject['quantity'], productObject)
                  } else if (!stateProviderId) {
                    let url = this.state.beepUrl
                    let audio = new Audio(url)
                    audio.play()
                    this.addDialogLastProduct(response)
                    this.createProductObject(productObject['stockProductId'], productObject['quantity'], productObject)
                  } else {
                    $('#id').select()
                    $('#id').val('')
                    $('#quantity').val('')
                    let url = this.state.wrongUrl
                    let audio = new Audio(url)
                    audio.play()
                    message.error('این کالا مربوط به این تامین کننده نیست')
                  }
                } else if (valueRadio == 'barcodeOnly' && idValue.length == '18') {
                  $('#quantity').select()
                  $('#id').val('')
                  $('#quantity').val('')

                  var temp = this.toEnDigit(idValue)
                  var extractWeight = temp.substring(13, 18)
                  productObject['quantity'] = Number(extractWeight / 1000)
                  idValue = ''
                  document.getElementById('quantity').value = ''

                  if (stateProviderId != '' && proId == stateProviderId) {
                    let url = this.state.beepUrl
                    let audio = new Audio(url)
                    audio.play()
                    this.addDialogLastProduct(response)
                    this.createProductObject(productObject['stockProductId'], productObject['quantity'], productObject)
                  } else if (!stateProviderId) {
                    let url = this.state.beepUrl
                    let audio = new Audio(url)
                    audio.play()
                    this.addDialogLastProduct(response)
                    this.createProductObject(productObject['stockProductId'], productObject['quantity'], productObject)
                  } else {
                    let url = this.state.wrongUrl
                    let audio = new Audio(url)
                    audio.play()
                    $('#id').select()
                    $('#id').val('')
                    $('#quantity').val('')
                    message.error('این کالا مربوط به این تامین کننده نیست')
                  }
                } else if (valueRadio == 'barcodeCount' && idValue.length == '16') {
                  $('#quantity').select()
                  $('#id').val('')
                  $('#quantity').val('')

                  var temp = this.toEnDigit(idValue)
                  var extractWeight = temp.substring(11, 16)
                  productObject['quantity'] = Number(extractWeight / 1000)
                  idValue = ''
                  document.getElementById('quantity').value = ''
                  if (stateProviderId != '' && proId == stateProviderId) {
                    let url = this.state.beepUrl
                    let audio = new Audio(url)
                    audio.play()
                    this.addDialogLastProduct(response)
                    this.createProductObject(productObject['stockProductId'], productObject['quantity'], productObject)
                  } else if (!stateProviderId) {
                    let url = this.state.beepUrl
                    let audio = new Audio(url)
                    audio.play()
                    this.addDialogLastProduct(response)
                    this.createProductObject(productObject['stockProductId'], productObject['quantity'], productObject)
                  } else {
                    let url = this.state.wrongUrl
                    let audio = new Audio(url)
                    audio.play()
                    $('#id').select()
                    $('#id').val('')
                    $('#quantity').val('')
                    message.error('این کالا مربوط به این تامین کننده نیست')
                  }
                } else if (valueRadio == 'barcodeCount' && idValue.length == '18') {
                  $('#quantity').select()
                  $('#id').val('')
                  $('#quantity').val('')

                  var temp = this.toEnDigit(idValue)
                  var extractWeight = temp.substring(13, 18)
                  productObject['quantity'] = Number(extractWeight / 1000)
                  idValue = ''
                  document.getElementById('quantity').value = ''

                  if (stateProviderId != '' && proId == stateProviderId) {
                    let url = this.state.beepUrl
                    let audio = new Audio(url)
                    audio.play()
                    this.addDialogLastProduct(response)
                    this.createProductObject(productObject['stockProductId'], productObject['quantity'], productObject)
                  } else if (!stateProviderId) {
                    let url = this.state.beepUrl
                    let audio = new Audio(url)
                    audio.play()
                    this.addDialogLastProduct(response)
                    this.createProductObject(productObject['stockProductId'], productObject['quantity'], productObject)
                  } else {
                    let url = this.state.wrongUrl
                    let audio = new Audio(url)
                    audio.play()
                    $('#id').select()
                    $('#id').val('')
                    $('#quantity').val('')
                    message.error('این کالا مربوط به این تامین کننده نیست')
                  }
                } else if (valueRadio == 'barcodeOnly' && (idValue.length != '16' && idValue.length != '18')) {
                  $('#id').select()
                  $('#id').val('')
                  $('#quantity').val('')

                  productObject['quantity'] = '1'

                  if (stateProviderId != '' && proId == stateProviderId) {
                    let url = this.state.beepUrl
                    let audio = new Audio(url)
                    audio.play()
                    this.addDialogLastProduct(response)
                    this.createProductObject(productObject['stockProductId'], productObject['quantity'], productObject)
                  } else if (!stateProviderId) {
                    let url = this.state.beepUrl
                    let audio = new Audio(url)
                    audio.play()
                    this.addDialogLastProduct(response)
                    this.createProductObject(productObject['stockProductId'], productObject['quantity'], productObject)
                  } else {
                    let url = this.state.wrongUrl
                    let audio = new Audio(url)
                    audio.play()
                    $('#id').select()
                    $('#id').val('')
                    $('#quantity').val('')
                    message.error('این کالا مربوط به این تامین کننده نیست')
                  }
                } else if (
                  valueRadio == 'barcodeCount' &&
                  quantity != '' &&
                  (idValue.length != '16' && idValue.length != '18')
                ) {
                  $('#id').select()
                  $('#id').val('')
                  $('#quantity').val('')

                  productObject['quantity'] = quantity
                  if (stateProviderId != '' && proId == stateProviderId) {
                    let url = this.state.beepUrl
                    let audio = new Audio(url)
                    audio.play()
                    this.addDialogLastProduct(response)
                    this.createProductObject(productObject['stockProductId'], productObject['quantity'], productObject)
                  } else if (!stateProviderId) {
                    let url = this.state.beepUrl
                    let audio = new Audio(url)
                    audio.play()
                    this.addDialogLastProduct(response)
                    this.createProductObject(productObject['stockProductId'], productObject['quantity'], productObject)
                  } else {
                    let url = this.state.wrongUrl
                    let audio = new Audio(url)
                    audio.play()
                    $('#id').select()
                    $('#id').val('')
                    $('#quantity').val('')
                    message.error('این کالا مربوط به این تامین کننده نیست')
                  }
                } else if (
                  valueRadio == 'barcodeCount' &&
                  quantity == '' &&
                  (idValue.length != '16' && idValue.length != '18')
                ) {
                  $('#quantity').select()
                  // $('#id').val('')
                  $('#quantity').val('')

                  message.error('تعداد را وارد کنید')
                } else if (valueRadio == 'barcodeOnly' && (idValue.length == '13' && idValue[0] != '6')) {
                  $('#id').select()
                  $('#id').val('')
                  $('#quantity').val('')

                  productObject['quantity'] = '1'

                  if (stateProviderId != '' && proId == stateProviderId) {
                    let url = this.state.beepUrl
                    let audio = new Audio(url)
                    audio.play()
                    this.addDialogLastProduct(response)
                    this.createProductObject(productObject['stockProductId'], productObject['quantity'], productObject)
                  } else if (!stateProviderId) {
                    let url = this.state.beepUrl
                    let audio = new Audio(url)
                    audio.play()
                    this.addDialogLastProduct(response)
                    this.createProductObject(productObject['stockProductId'], productObject['quantity'], productObject)
                  } else {
                    let url = this.state.wrongUrl
                    let audio = new Audio(url)
                    audio.play()
                    $('#id').select()
                    $('#id').val('')
                    $('#quantity').val('')
                    message.error('این کالا مربوط به این تامین کننده نیست')
                  }
                } else if (valueRadio == 'barcodeCount' && (idValue.length == '13' && idValue[0] != '6')) {
                  $('#id').select()
                  $('#id').val('')
                  $('#quantity').val('')

                  productObject['quantity'] = quantity

                  if (stateProviderId != '' && proId == stateProviderId) {
                    let url = this.state.beepUrl
                    let audio = new Audio(url)
                    audio.play()
                    this.addDialogLastProduct(response)
                    this.createProductObject(productObject['stockProductId'], productObject['quantity'], productObject)
                  } else if (!stateProviderId) {
                    let url = this.state.beepUrl
                    let audio = new Audio(url)
                    audio.play()
                    this.addDialogLastProduct(response)
                    this.createProductObject(productObject['stockProductId'], productObject['quantity'], productObject)
                  } else {
                    let url = this.state.wrongUrl
                    let audio = new Audio(url)
                    audio.play()
                    $('#id').select()
                    $('#id').val('')
                    $('#quantity').val('')
                    message.error('این کالا مربوط به این تامین کننده نیست')
                  }
                }
              }
            } else {
              let url = this.state.wrongUrl
              let audio = new Audio(url)
              audio.play()
              this.setState({
                sendRequest: true
              })

              // message.error(response.data.description)
              // $('#id').select()
              $('#id').select()
              $('#id').val('')
              $('#quantity').val('')
            }
            // this.setState({
            //     sendRequest: false
            // }, () => {

            // })
          })
          .catch((error) => {
            this.setState({
              sendRequest: true
            })
            //alert(JSON.stringify(error))
          })
      }
    }
  }

  delete = (rowId) => {
    const object = {
      id: this.state.product[rowId].stockProductId,
      quantity: this.state.product[rowId].quantity
    }
    var index = this.state.details.findIndex((details) => details.id === object.id)
    // var find = this.state.details.find(details => details.id === object.id);
    this.setState({
      lastEnteredProduct: {
        name: this.state.product[rowId].productName,
        barcode: this.state.product[rowId].productCode,
        time: jMoment().format('HH:mm'),
        count: this.state.product[rowId].quantity,
        unit: this.state.product[rowId].productUnitTitle
      },
      addProduct: false,
      removeProduct: true
    })
    this.state.details.splice(index, 1)
    this.state.product.splice(rowId, 1)

    this.setState(
      {
        product: this.state.product,
        details: this.state.details
      },
      () => {
        let urlParams = new URLSearchParams(window.location.search)
        let preRecordId = urlParams.get('id') === null ? '' : urlParams.get('id')
        let ls = JSON.parse(localStorage.getItem('objectAddPreRecord' + preRecordId))
        ls['product'] = this.state.product
        ls['details'] = this.state.details
        localStorage.setItem('objectAddPreRecord' + preRecordId, JSON.stringify(ls))
        if (this.state.product.length === 0) {
          this.setState({
            showLastProduct: false
          })
        }
      }
    )

    this.setState(this.state.product)
    this.setState(this.state.details)
    if (this.state.product.length == '0') {
      this.setState({
        fadeTable: 'true'
      })
    }
  }

  double = (rowId) => {
    let productObject = this.state.searchesProduct[rowId]
    this.quantity.focus()
    this.barcode.value = productObject['productCode']
    this.setState({
      modal: !this.state.modal,
      searchesProduct: [],
      searchTablevisibility: false
    })
  }

  changeCount = (rowId, value) => {
    let target = rowId.target

    const object = {
      id: this.state.product[rowId].stockProductId,
      quantity: this.state.product[rowId].quantity
    }

    var index = this.state.details.findIndex((details) => details.id === object.id)

    const {details} = this.state

    // alert(value)
    const {product} = this.state
    this.setState(
      (prevState) => {
        const newDetails = details
        const newProduct = product
        newProduct[rowId].quantity = value
        newDetails[index].quantity = value
        return {
          product: newProduct,
          details: newDetails
        }
      },
      () => {
        let urlParams = new URLSearchParams(window.location.search)
        let preRecordId = urlParams.get('id') === null ? '' : urlParams.get('id')
        let ls = JSON.parse(localStorage.getItem('objectAddPreRecord' + preRecordId))
        ls['product'] = this.state.product
        ls['details'] = this.state.details
        localStorage.setItem('objectAddPreRecord' + preRecordId, JSON.stringify(ls))
      }
    )
  }

  epochTo = (x) => {
    if (
      x.match(
        /^[1-4]\d{3}\/((0[1-6]\/((3[0-1])|([1-2][0-9])|(0[1-9])))|((1[0-2]|(0[7-9]))\/(30|([1-2][0-9])|(0[1-9]))))$/
      )
    ) {
      var concatDayMount = x.split('/')
      var concatDate = concatDayMount[1] + concatDayMount[2]
      var constantDate = '0631'
      var n = concatDate.localeCompare(constantDate)
      let miladiDate = jMoment(x, 'jYYYY/jM/jD').format('YYYY/M/D')
      let to = miladiDate + ' ' + '23:59:59'
      let toEpoch = moment.utc(to).valueOf()
      if (n >= 0) {
        return toEpoch - 3.5 * 3600 * 1000
      } else if (n < 0 && concatDate === '0101') {
        return toEpoch - 3.5 * 3600 * 1000
      } else {
        return toEpoch - 3.5 * 3600 * 1000
      }
    }
  }

  epochFrom = (x) => {
    if (
      x.match(
        /^[1-4]\d{3}\/((0[1-6]\/((3[0-1])|([1-2][0-9])|(0[1-9])))|((1[0-2]|(0[7-9]))\/(30|([1-2][0-9])|(0[1-9]))))$/
      )
    ) {
      var concatDayMount = x.split('/')
      var concatDate = concatDayMount[1] + concatDayMount[2]
      var constantDate = '0631'
      var n = concatDate.localeCompare(constantDate)
      let miladiDate = jMoment(x, 'jYYYY/jM/jD').format('YYYY/M/D')
      let from = miladiDate + ' ' + '00:00'
      let fromEpoch = moment.utc(from).valueOf()
      if (n >= 0) {
        return fromEpoch - 3.5 * 3600 * 1000
      } else if (n < 0 && concatDate === '0101') {
        return fromEpoch - 3.5 * 3600 * 1000
      } else {
        return fromEpoch - 3.5 * 3600 * 1000
      }
    }
  }

  convertDigit = (string) => {
    return string
      .replace(/[\u0660-\u0669]/g, function(c) {
        return c.charCodeAt(0) - 0x0660
      })
      .replace(/[\u06f0-\u06f9]/g, function(c) {
        return c.charCodeAt(0) - 0x06f0
      })
  }

  setValueRefFactorNumber = (isInput, refType, isInternal) => {
    if (isInternal) return null
    if (!refType) return !this.state.refFactorNo ? null : this.state.refFactorNo
    if (refType === 'CUSTOMER' && isInput) return !this.state.refFactorNo ? null : this.state.refFactorNo
    if (refType === 'PROVIDER' && isInput) return !this.state.refFactorNo ? null : this.state.refFactorNo
    if (refType === 'PROVIDER' && !isInput) return null
    if (refType === 'CUSTOMER' && isInput) return !this.state.refFactorNo ? null : this.state.refFactorNo
    if (refType === 'CUSTOMER' && !isInput) return !this.state.refFactorNo ? null : this.state.refFactorNo
  }

  getInvoiceNumValue = () => {
    if (this.showInvoiceNumInvoiceDate().show) {
      return this.state.refFactorNo
    } else {
      return null
    }
  }

  getInvoiceDateValue = () => {
    if (this.showInvoiceNumInvoiceDate().show) {
      return this.convertDigit(document.getElementById('refFactorDate').value)
    } else {
      return null
    }
  }

  getDocId() {
    var {
      refType,
      typeWarehouseId,
      isInternal,
      typeDocId,
      refWarehouseId,
      anbarType,
      providerId,
      anbarTypeTaraf
    } = this.state

    let manualRegisterDate = this.convertDigit(document.getElementById('manualRegisterDate').value)
    let refFactorDate = this.getInvoiceDateValue()
    let refFactorNo = this.getInvoiceNumValue()

    var isInput = document.getElementById('isInput').value
    var description = document.getElementById('description').value
    var boolIsInput = isInput == 'true'
    let providerCheck = this.state.providerId

    // if (isInternal) {
    //     refFactorDate = null
    // }
    // if (boolIsInput && !isInternal) {
    //     refFactorDate = this.convertDigit(document.getElementById('refFactorDate').value);

    // }

    // if (!boolIsInput && refType === 'CUSTOMER' && !this.state.isInternal) {

    //     refFactorDate = this.convertDigit(document.getElementById('refFactorDate').value);
    // }

    // if (refType === '' && !this.state.isInternal) {
    //     refFactorDate = this.convertDigit(document.getElementById('refFactorDate').value);
    // }

    var providerId = null
    if (!this.state.isInternal) {
      providerId = this.state.providerId
    }

    var submitForm = false
    var confirmErr = false
    var wareNameError = false
    var isinputError = false
    var doctypeError = false
    var refFacNO = false
    var manufactor = false
    var quantityTableError = false
    // alert(JSON.stringify(this.state.product))
    let findWithOutManufactor = this.state.details.find((item) => item.manufactureDate === '')
    if (findWithOutManufactor && anbarType === 3 && boolIsInput) {
      submitForm = true
      manufactor = true
      message.error('در سند انبار اصلی وارده تاریخ تولید برای تمامی کالا ها الزامیست')
    } else {
      if (!manufactor) {
      }
    }

    $('.ashar').each(function() {
      if ($(this).val() <= '0') {
        submitForm = true
        quantityTableError = true
        $(this).css('borderColor', '#f2682e')
        $(this).css('box-shadow', '0 0 0 0.2rem #fbd1c0')
      } else if (
        $(this)
          .val()
          .match(/[a-z A-Z آ-ی]/g)
      ) {
        submitForm = true
        quantityTableError = true
        $(this).css('borderColor', '#f2682e')
        $(this).css('box-shadow', '0 0 0 0.2rem #fbd1c0')
      } else if (
        $(this)
          .val()
          .match(/[!@#$%^&*()\-+,?":{}=|<>]/g)
      ) {
        submitForm = true
        quantityTableError = true
        $(this).css('borderColor', '#f2682e')
        $(this).css('box-shadow', '0 0 0 0.2rem #fbd1c0')
      } else {
        $(this).css('borderColor', '#65e251')
        $(this).css('box-shadow', '0 0 0 0.2rem #cfedcb')
        if (!quantityTableError) {
          console.log('sd')
        }
      }
    })

    $('.sahih').each(function() {
      if (
        $(this)
          .val()
          .match(/\-?\d+\.\d+/g)
      ) {
        submitForm = true
        quantityTableError = true
        $(this).css('borderColor', '#f2682e')
        $(this).css('box-shadow', '0 0 0 0.2rem #fbd1c0')
        $('#errorCountText').html('واحد صحیح کالا مقدار اعشاری نمیپذیرد')
      } else if ($(this).val() < '1') {
        submitForm = true
        quantityTableError = true
        $(this).css('borderColor', '#f2682e')
        $(this).css('box-shadow', '0 0 0 0.2rem #fbd1c0')
        $('#errorCountText').html('واحد صحیح کالا مقدار کمتر از یک نمیپذیرد')
      } else if (
        $(this)
          .val()
          .match(/[!@#$%^&*()\-+.,?":{}=|<>]/g)
      ) {
        submitForm = true
        quantityTableError = true
        $(this).css('borderColor', '#f2682e')
        $(this).css('box-shadow', '0 0 0 0.2rem #fbd1c0')
      } else if (
        $(this)
          .val()
          .match(/[a-z A-Z آ-ی]/g)
      ) {
        submitForm = true
        quantityTableError = true
        $(this).css('borderColor', '#f2682e')
        $(this).css('box-shadow', '0 0 0 0.2rem #fbd1c0')
      } else if ($(this).val() <= '0') {
        submitForm = true
        quantityTableError = true
        $(this).css('borderColor', '#f2682e')
        $(this).css('box-shadow', '0 0 0 0.2rem #fbd1c0')
      } else {
        $(this).css('borderColor', '#65e251')
        $(this).css('box-shadow', '0 0 0 0.2rem #cfedcb')
        if (!quantityTableError) {
          $('#errorCountText').html('')

          console.log('sd')
        }
      }
    })

    let parcelId
    if (refType === 'CUSTOMER' && !this.state.isInternal) {
      parcelId = this.state.parcelId
    } else {
      parcelId = null
    }

    if (refType === 'CUSTOMER' && !this.state.isInternal && !parcelId) {
      message.error('شناسه مرسوله الزامی است')
      submitForm = true
    }

    if (refType === 'CUSTOMER' && boolIsInput && !refFactorNo) {
      message.error('شماره فاکتور الزامی است')
      submitForm = true
    }

    if (refType === 'CUSTOMER' && !boolIsInput && !refFactorNo && !this.state.isInternal) {
      message.error('شماره فاکتور الزامی است')
      submitForm = true
    }

    if (!this.state.isInternal && !refType) {
      message.error('نوع طرف الزامی است')
      submitForm = true
    }

    // if (refType === 'CUSTOMER' && !boolIsInput && !refFactorDate && !this.state.isInternal) {
    //     message.error('تاریخ فاکتور الزامی است')
    //     submitForm = true;
    // }

    // if (!(refFactorNo == '') && refFactorNo.match(/[a-z A-Z]/g) || refFactorNo.match(/[!@#$%^&*()\-+,.?":{}=|<>]/g)) {
    //     message.error('شماره فاکتور باید عدد صحیح باشد');
    //     submitForm = true;
    //     refFacNO = true;
    // } else {
    //     if (!refFacNO) {
    //         {
    //             console.log('sd')
    //         }
    //     }
    // }

    if (typeWarehouseId == '') {
      message.error('انبار را مشخص کنید')
      submitForm = true
      wareNameError = true
      this.setState({
        errorForm: {
          warehouseName: 'انبار را مشخص کنید'
        }
      })
    } else {
      if (!wareNameError) {
        this.setState({
          errorForm: {
            warehouseName: ''
          }
        })
      }
    }

    if (isInput == '') {
      message.error('ماهیت را مشخص کنید')

      isinputError = true
      submitForm = true
      this.setState({
        errorForm: {
          isInputError: 'ماهیت را مشخص کنید'
        }
      })
    } else {
      if (!isinputError) {
        this.setState({
          errorForm: {
            isInputError: ''
          }
        })
      }
    }

    if (typeDocId == '') {
      message.error('نوع سند را مشخص کنید')

      doctypeError = true
      submitForm = true

      this.setState({
        errorForm: {
          warehouseTypeError: 'نوع سند را مشخص کنید'
        }
      })
    } else {
      if (!doctypeError) {
        this.setState({
          errorForm: {
            warehouseTypeError: ''
          }
        })
      }
    }
    if (isInternal) {
      if (refWarehouseId == '') {
        submitForm = true
        message.error('انبار طرف را مشخص کنید')
      } else if (refWarehouseId === typeWarehouseId) {
        submitForm = true
        message.error('انبار طرف نباید با انبار یکسان باشد')
      } else {
        this.setState({
          errorDocForm: ''
        })

        var docData = {
          parcelId,
          refType: !refType || this.state.isInternal ? null : refType,
          typeWarehouseId: this.state.typeWarehouseId,
          isInput: boolIsInput,
          isInternal: this.state.isInternal,
          abnormal: this.state.abnormal,
          typeDocId: this.state.typeDocId,
          details: this.state.details,
          description: description == '' ? undefined : description,
          refWarehouseId: this.state.isInternal ? this.state.refWarehouseId : null,
          manualRegisterDate: manualRegisterDate == null ? undefined : this.epochFrom(manualRegisterDate),
          providerId,
          receiverId: this.state.receiverId == '' ? undefined : this.state.receiverId,
          senderId: this.state.senderId == '' ? undefined : this.state.senderId,
          senderName: this.state.senderName == '' ? undefined : this.state.senderName,
          receiverName: this.state.receiverName == '' ? undefined : this.state.receiverName,
          refFactorDate: !refFactorDate ? undefined : this.epochFrom(refFactorDate),
          refFactorNo: this.setValueRefFactorNumber(boolIsInput, refType, this.state.isInternal),
          checkRemain: false,
          otherSellers: this.state.otherSellers
        }
      }
    } else {
      this.setState({
        errorDocForm: ''
      })
      var docData = {
        parcelId,
        refType: !refType || this.state.isInternal ? null : refType,
        typeWarehouseId: this.state.typeWarehouseId,
        isInput: boolIsInput,
        isInternal: this.state.isInternal,
        abnormal: this.state.abnormal,
        typeDocId: this.state.typeDocId,
        details: this.state.details,
        description: description == '' ? undefined : description,
        manualRegisterDate: manualRegisterDate == null ? undefined : this.epochFrom(manualRegisterDate),
        providerId,
        receiverId: this.state.receiverId == '' ? undefined : this.state.receiverId,
        senderId: this.state.senderId == '' ? undefined : this.state.senderId,
        senderName: this.state.senderName == '' ? undefined : this.state.senderName,
        receiverName: this.state.receiverName == '' ? undefined : this.state.receiverName,
        refFactorDate: !refFactorDate ? undefined : this.epochFrom(refFactorDate),
        refFactorNo: this.setValueRefFactorNumber(boolIsInput, refType, this.state.isInternal),
        checkRemain: false,
        otherSellers: this.state.otherSellers
      }
    }

    if (!submitForm) {
      if (anbarType === 3 && boolIsInput) {
        message.error('لطفا از انبار واسط استفاده کنید')
      } else if (anbarType === 6 && boolIsInput && !isInternal && providerCheck === '' && !this.state.otherSellers) {
        message.error('تامین کننده باید انتخاب شود')
      } else if (anbarType === 3 && boolIsInput && !isInternal && providerCheck === '') {
        if (confirm('با توجه به اطلاعات ورودی شما تامین کننده انتخاب نشده است.آیا از ادامه عملیات اطمینان دارید؟')) {
          this.setState({
            modalConfirm: !this.state.modalConfirm,
            incompatibleRemainProducts: [],
            incompatibleSupplyOrderProducts: [],
            incompatibleDispatchProducts: []
          })
        }
      } else if (anbarType === 6 && !boolIsInput && isInternal && anbarTypeTaraf !== 5) {
        if (confirm('با توجه به اطلاعات ورودی شما انبار طرف باید انبارک باشد.آیا از ادامه عملیات اطمینان دارید؟')) {
          this.setState({
            modalConfirm: !this.state.modalConfirm,
            incompatibleRemainProducts: [],
            incompatibleSupplyOrderProducts: [],
            incompatibleDispatchProducts: []
          })
        }
      } else {
        this.setState({
          modalConfirm: !this.state.modalConfirm,
          incompatibleRemainProducts: [],
          incompatibleSupplyOrderProducts: [],
          incompatibleDispatchProducts: []
        })
      }
    }
  }

  cancelConfirm() {
    this.setState({
      modalConfirm: false
    })
  }

  setPreRecord() {
    var {
      refType,
      typeWarehouseId,
      isInternal,
      typeDocId,
      refWarehouseId,
      providerValue,
      receiverId,
      receiverName,
      senderId,
      senderName,
      providerId,
      details
    } = this.state
    let manualRegisterDate = this.convertDigit(document.getElementById('manualRegisterDate').value)

    let refFactorDate = this.getInvoiceDateValue()
    let refFactorNo = this.getInvoiceNumValue()
    // let refFactorDate = null

    var isInput = document.getElementById('isInput').value

    var boolIsInput = isInput == 'true'

    // if (isInternal) {
    //     refFactorDate = null
    // }

    // if (boolIsInput && !isInternal) {
    //     refFactorDate = this.convertDigit(document.getElementById('refFactorDate').value);

    // }

    // if (!boolIsInput && refType === 'CUSTOMER' && !this.state.isInternal) {

    //     refFactorDate = this.convertDigit(document.getElementById('refFactorDate').value);
    // }

    // if (refType === '' && !this.state.isInternal) {
    //     refFactorDate = this.convertDigit(document.getElementById('refFactorDate').value);
    // }

    var description = document.getElementById('description').value

    var providerId = null
    if (!this.state.isInternal) {
      providerId = this.state.providerId
    }

    if (description == '') {
      this.setState({
        description: undefined
      })
    } else {
      let dataDoc = {
        describtion: this.state.description
      }
    }

    if (manualRegisterDate == '') {
      this.setState({
        manualRegisterDate: undefined
      })
    } else {
      let dataDoc = {
        manualRegisterDate: manualRegisterDate
      }
    }

    if (receiverId == '') {
      this.setState({
        receiverId: undefined
      })
    } else {
      let dataDoc = {
        receiverId: this.state.receiverId
      }
    }

    if (senderId == '') {
      this.setState({
        senderId: undefined
      })
    } else {
      let dataDoc = {
        senderId: this.state.senderId
      }
    }

    if (senderName == '') {
      this.setState({
        senderName: undefined
      })
    } else {
      let dataDoc = {
        senderName: this.state.senderName
      }
    }

    if (providerId == '') {
      this.setState({
        providerId: ''
      })
    } else {
      let dataDoc = {
        providerId: this.state.senderName
      }
    }

    if (refFactorNo == '') {
      this.setState({
        refFactorNo: ''
      })
    } else {
      let dataDoc = {
        refFactorNo: this.state.refFactorNo
      }
    }

    // if (refFactorDate == '') {
    //     this.setState({
    //         refFactorDate: undefined
    //     })
    // } else {
    //     let dataDoc = {
    //         refFactorDate: refFactorDate
    //     }
    // }

    var submitForm = false
    var wareNameError = false
    var isinputError = false
    var doctypeError = false
    var refFacNO = false
    var quantityTableError = false

    $('.sahih').each(function() {
      if ($(this).val() < '1') {
        submitForm = true
        quantityTableError = true
        $(this).css('borderColor', '#f2682e')
        $(this).css('box-shadow', '0 0 0 0.2rem #fbd1c0')
      } else if (
        $(this)
          .val()
          .match(/\-?\d+\.\d+/g)
      ) {
        submitForm = true
        quantityTableError = true
        $(this).css('borderColor', '#f2682e')
        $(this).css('box-shadow', '0 0 0 0.2rem #fbd1c0')
        $('#errorCountText').html('واحد صحیح کالا مقدار اعشاری نمیپذیرد')
      } else if (
        $(this)
          .val()
          .match(/[!@#$%^&*()\-+,.?":{}=|<>]/g)
      ) {
        submitForm = true
        quantityTableError = true
        $(this).css('borderColor', '#f2682e')
        $(this).css('box-shadow', '0 0 0 0.2rem #fbd1c0')
      } else if ($(this).val() <= '0') {
        submitForm = true
        quantityTableError = true
        $(this).css('borderColor', '#f2682e')
        $(this).css('box-shadow', '0 0 0 0.2rem #fbd1c0')
      } else if (
        $(this)
          .val()
          .match(/[a-z A-Z آ-ی]/g)
      ) {
        submitForm = true
        quantityTableError = true
        $(this).css('borderColor', '#f2682e')
        $(this).css('box-shadow', '0 0 0 0.2rem #fbd1c0')
      } else {
        $(this).css('borderColor', '#65e251')
        $(this).css('box-shadow', '0 0 0 0.2rem #cfedcb')
        $('#errorCountText').html('')

        if (!quantityTableError) {
          console.log('sd')
        }
      }
    })

    $('.ashar').each(function() {
      if ($(this).val() <= '0') {
        submitForm = true
        quantityTableError = true
        $(this).css('borderColor', '#f2682e')
        $(this).css('box-shadow', '0 0 0 0.2rem #fbd1c0')
      } else if (
        $(this)
          .val()
          .match(/[!@#$%^&*()\-+,?":{}=|<>]/g)
      ) {
        submitForm = true
        quantityTableError = true
        $(this).css('borderColor', '#f2682e')
        $(this).css('box-shadow', '0 0 0 0.2rem #fbd1c0')
      } else if (
        $(this)
          .val()
          .match(/[a-z A-Z آ-ی]/g)
      ) {
        submitForm = true
        quantityTableError = true
        $(this).css('borderColor', '#f2682e')
        $(this).css('box-shadow', '0 0 0 0.2rem #fbd1c0')
      } else {
        $(this).css('borderColor', '#65e251')
        $(this).css('box-shadow', '0 0 0 0.2rem #cfedcb')
        if (!quantityTableError) {
          console.log('sd')
        }
      }
    })

    let parcelId
    if (refType === 'CUSTOMER' && !this.state.isInternal) {
      parcelId = this.state.parcelId
    } else {
      parcelId = null
    }

    if (refType === 'CUSTOMER' && boolIsInput && !refFactorNo) {
      message.error('شماره فاکتور الزامی است')
      submitForm = true
    }

    if (refType === 'CUSTOMER' && !boolIsInput && !refFactorNo && !this.state.isInternal) {
      message.error('شماره فاکتور الزامی است')
      submitForm = true
    }

    if (refType === 'CUSTOMER' && !isInternal && !parcelId) {
      message.error('شناسه مرسوله الزامی است')
      submitForm = true
    }

    // if (refType === 'CUSTOMER' && !boolIsInput && !refFactorDate && !this.state.isInternal) {
    //     message.error('تاریخ فاکتور الزامی است')
    //     submitForm = true;
    // }

    // if (!(refFactorNo == '') && refFactorNo.match(/[a-z A-Z]/g)) {
    //     message.error('شماره فاکتور باید عدد صحیح باشد');
    //     submitForm = true;
    //     refFacNO = true;
    // } else {
    //     if (!refFacNO) {
    //         {
    //             console.log('sd')
    //         }
    //     }
    // }

    if (typeWarehouseId == '') {
      message.error('انبار را مشخص کنید')
      submitForm = true
      wareNameError = true
      this.setState({
        errorForm: {
          warehouseName: 'انبار را مشخص کنید'
        }
      })
    } else {
      if (!wareNameError) {
        this.setState({
          errorForm: {
            warehouseName: ''
          }
        })
      }
    }

    if (isInput == '') {
      message.error('ماهیت را مشخص کنید')

      isinputError = true
      submitForm = true
      this.setState({
        errorForm: {
          isInputError: 'ماهیت را مشخص کنید'
        }
      })
    } else {
      if (!isinputError) {
        this.setState({
          errorForm: {
            isInputError: ''
          }
        })
      }
    }

    if (typeDocId == '') {
      message.error('نوع سند را مشخص کنید')

      var doctypeError = true
      this.setState({
        errorForm: {
          warehouseTypeError: 'نوع سند را مشخص کنید'
        }
      })
    } else {
      if (!doctypeError) {
        this.setState({
          errorForm: {
            warehouseTypeError: ''
          }
        })
      }
    }

    if (isInternal) {
      if (refWarehouseId == '') {
        submitForm = true
        message.error('انبار طرف را مشخص کنید')
      } else {
        this.setState({
          errorDocForm: ''
        })

        var docData = {
          parcelId,
          refType: !refType || this.state.isInternal ? null : refType,
          typeWarehouseId: this.state.typeWarehouseId,
          isInput: boolIsInput,
          isInternal: this.state.isInternal,
          abnormal: this.state.abnormal,
          typeDocId: this.state.typeDocId,
          details: this.state.details,
          description: description == '' ? undefined : description,
          refWarehouseId: this.state.isInternal ? this.state.refWarehouseId : null,
          manualRegisterDate: manualRegisterDate == null ? undefined : this.epochFrom(manualRegisterDate),
          providerId,
          receiverId: this.state.receiverId == '' ? undefined : this.state.receiverId,
          senderId: this.state.senderId == '' ? undefined : this.state.senderId,
          senderName: this.state.senderName == '' ? undefined : this.state.senderName,
          receiverName: this.state.receiverName == '' ? undefined : this.state.receiverName,
          refFactorDate: !refFactorDate ? undefined : this.epochFrom(refFactorDate),
          refFactorNo: this.setValueRefFactorNumber(boolIsInput, refType, this.state.isInternal),
          checkIncompatible: true,
          otherSellers: this.state.otherSellers
        }
      }
    } else {
      this.setState({
        errorDocForm: ''
      })
      var docData = {
        parcelId,
        refType: !refType || this.state.isInternal ? null : refType,
        typeWarehouseId: this.state.typeWarehouseId,
        isInput: boolIsInput,
        isInternal: this.state.isInternal,
        abnormal: this.state.abnormal,
        typeDocId: this.state.typeDocId,
        details: this.state.details,
        description: description == '' ? undefined : description,
        manualRegisterDate: manualRegisterDate == null ? undefined : this.epochFrom(manualRegisterDate),
        providerId,

        receiverId: this.state.receiverId == '' ? undefined : this.state.receiverId,
        senderId: this.state.senderId == '' ? undefined : this.state.senderId,
        senderName: this.state.senderName == '' ? undefined : this.state.senderName,
        receiverName: this.state.receiverName == '' ? undefined : this.state.receiverName,
        refFactorDate: !refFactorDate ? undefined : this.epochFrom(refFactorDate),
        refFactorNo: this.setValueRefFactorNumber(boolIsInput, refType, this.state.isInternal),
        checkIncompatible: true,
        otherSellers: this.state.otherSellers
      }
    }

    if (!submitForm) {
      this.setState({
        loading: true
      })

      http
        .post(`${WAREHOUSE.WAREHOUSE_DOCUEMNT_RECORD_PREVIEW}`, docData, {})
        .then((response) => {
          this.setState({
            loading: false
          })
          if (response.data.description != null) {
            message.error(response.data.description)
          } else if (response.data.object.unMatch) {
            this.setState({
              modalError: !this.state.modalError,
              modalConfirm: false,
              unMatchProduct: response.data.object.unMatchProducts,
              tableNotFound: true,
              tableNotRemain: false,
              textUnMatch: 'این اجناس در انبار انتخاب شده وجود ندارد',
              loading: false
            })
          } else if (response.data.object.incompatible) {
            this.setState({
              modalError: !this.state.modalError,
              modalConfirm: false,
              incompatibleRemainProducts: response.data.object.incompatibleRemainProducts,
              incompatibleSupplyOrderProducts: response.data.object.incompatibleSupplyOrderProducts,
              incompatibleDispatchProducts: response.data.object.incompatibleDispatchProducts,
              tableNotFound: false,
              tableNotRemain: true,
              textUnMatch: '',
              deliveryDates: response.data.object.deliveryDates,
              loading: false
            })
            if (boolIsInput && !this.state.isInternal && this.state.anbarType === 3) {
              this.setState({
                loading: false
              })
              if (this.state.incompatibleSupplyOrderProducts.length > 0) {
                this.setState({
                  showClipboardBtn: true
                })
              } else {
                this.setState({
                  showClipboardBtn: false
                })
              }
            } else if (boolIsInput && !this.state.isInternal && this.state.anbarType === 6) {
              this.setState({
                loading: false
              })
              if (this.state.incompatibleSupplyOrderProducts.length > 0) {
                this.setState({
                  showClipboardBtn: true
                })
              } else {
                this.setState({
                  showClipboardBtn: false
                })
              }
            }
          } else {
            this.setState({
              loading: false
            })
            let successError = 'پیش سند با شماره ' + response.data.object.preDocId + ' ثبت شد.لطفا صبر کنید '
            message.success(successError)
            this.setState(
              {
                modalConfirm: false,
                modalError: false
              },
              () => {
                if (boolIsInput && !this.state.isInternal && this.state.anbarType === 3) {
                  let manualRegisterDate = this.convertDigit(document.getElementById('manualRegisterDate').value)
                  localStorage.setItem(
                    'clipText',
                    this.copyClipBoard(this.state.incompatibleSupplyOrderProducts, 'show')
                  )
                  let providerId = this.state.providerId
                  this.setState(
                    {
                      modalConfirm: false
                    },
                    () => {
                      window.open(
                        `/warehouse/link?showPrintLink=${true}&hasUnmatch=${false}&preRecordId=${
                          response.data.object.preDocId
                        }&providerId=${providerId}&date=${manualRegisterDate}`,
                        '_blank'
                      )
                      setTimeout(() => {
                        let data = {
                          typeWarehouseId: '',
                          checkIsInput: '',
                          typeDocId: '',
                          isInternal: false,
                          abnormal: false,
                          senderName: '',
                          receiverName: '',
                          refFactorNo: '',
                          description: '',
                          manualRegVal: moment(),
                          refFactor: null,
                          refWarehouseId: '',
                          providerId: '',
                          product: [],
                          details: [],
                          anbarTypeTaraf: '',
                          anbarType: '',
                          parcelId: ''
                        }
                        let urlParams = new URLSearchParams(window.location.search)
                        let preRecordId = urlParams.get('id') === null ? '' : urlParams.get('id')
                        localStorage.setItem('objectAddPreRecord' + preRecordId, JSON.stringify(data))
                        window.location.assign('/addPreRecord?id=' + preRecordId)
                      }, 3000)
                    }
                  )
                } else if (boolIsInput && !this.state.isInternal && this.state.anbarType === 6) {
                  let manualRegisterDate = this.convertDigit(document.getElementById('manualRegisterDate').value)
                  localStorage.setItem(
                    'clipText',
                    this.copyClipBoard(this.state.incompatibleSupplyOrderProducts, 'show')
                  )
                  let providerId = this.state.providerId
                  this.setState(
                    {
                      modalConfirm: false
                    },
                    () => {
                      window.open(
                        `/warehouse/link?showPrintLink=${true}&hasUnmatch=${false}&preRecordId=${
                          response.data.object.preDocId
                        }&providerId=${providerId}&date=${manualRegisterDate}`,
                        '_blank'
                      )
                      setTimeout(() => {
                        let data = {
                          typeWarehouseId: '',
                          checkIsInput: '',
                          typeDocId: '',
                          isInternal: false,
                          abnormal: false,
                          senderName: '',
                          receiverName: '',
                          refFactorNo: '',
                          description: '',
                          manualRegVal: moment(),
                          refFactor: null,
                          refWarehouseId: '',
                          providerId: '',
                          product: [],
                          details: [],
                          anbarTypeTaraf: '',
                          anbarType: '',
                          parcelId: ''
                        }
                        let urlParams = new URLSearchParams(window.location.search)
                        let preRecordId = urlParams.get('id') === null ? '' : urlParams.get('id')
                        localStorage.setItem('objectAddPreRecord' + preRecordId, JSON.stringify(data))
                        window.location.assign('/addPreRecord?id=' + preRecordId)
                      }, 3000)
                    }
                  )
                }
              }
            )

            this.setState({
              modalConfirm: false
            })
            setTimeout(() => {
              let data = {
                typeWarehouseId: '',
                checkIsInput: '',
                typeDocId: '',
                isInternal: false,
                abnormal: false,
                senderName: '',
                receiverName: '',
                refFactorNo: '',
                description: '',
                manualRegVal: moment(),
                refFactor: null,
                refWarehouseId: '',
                providerId: '',
                product: [],
                details: [],
                anbarTypeTaraf: '',
                anbarType: '',
                parcelId: ''
              }
              let urlParams = new URLSearchParams(window.location.search)
              let preRecordId = urlParams.get('id') === null ? '' : urlParams.get('id')
              localStorage.setItem('objectAddPreRecord' + preRecordId, JSON.stringify(data))
              window.location.assign('/addPreRecord?id=' + preRecordId)
            }, 3000)
          }
        })
        .catch((error) => {
          this.setState({
            loading: false
          })
        })
    }
  }

  cancelError() {
    this.setState({
      modalError: false
    })
  }

  setFinalyPreRecord() {
    var {
      refType,
      typeWarehouseId,
      isInternal,
      typeDocId,
      refWarehouseId,
      describtion,
      providerValue,
      receiverId,
      receiverName,
      senderId,
      senderName,
      providerId,
      details
    } = this.state
    let manualRegisterDate = this.convertDigit(document.getElementById('manualRegisterDate').value)

    // let refFactorDate = null
    let refFactorDate = this.getInvoiceDateValue()
    let refFactorNo = this.getInvoiceNumValue()

    var isInput = document.getElementById('isInput').value
    var description = document.getElementById('description').value

    var boolIsInput = isInput == 'true'

    var providerId = null
    if (!this.state.isInternal) {
      providerId = this.state.providerId
    }

    // if (isInternal) {
    //     refFactorDate = null
    // }
    // if (boolIsInput && !isInternal) {
    //     refFactorDate = this.convertDigit(document.getElementById('refFactorDate').value);
    // }

    // if (!boolIsInput && refType === 'CUSTOMER' && !this.state.isInternal) {

    //     refFactorDate = this.convertDigit(document.getElementById('refFactorDate').value);
    // }

    // if (refType === '' && !this.state.isInternal) {
    //     refFactorDate = this.convertDigit(document.getElementById('refFactorDate').value);
    // }

    if (describtion == '') {
      this.setState({
        description: undefined
      })
    } else {
      let dataDoc = {
        describtion: this.state.description
      }
    }

    if (manualRegisterDate == '') {
      this.setState({
        manualRegisterDate: undefined
      })
    } else {
      let dataDoc = {
        manualRegisterDate: manualRegisterDate
      }
    }

    if (receiverId == '') {
      this.setState({
        receiverId: undefined
      })
    } else {
      let dataDoc = {
        receiverId: this.state.receiverId
      }
    }

    if (senderId == '') {
      this.setState({
        senderId: undefined
      })
    } else {
      let dataDoc = {
        senderId: this.state.senderId
      }
    }

    if (senderName == '') {
      this.setState({
        senderName: undefined
      })
    } else {
      let dataDoc = {
        senderName: this.state.senderName
      }
    }

    if (providerId == '') {
      this.setState({
        providerId: ''
      })
    } else {
      let dataDoc = {
        providerId: this.state.senderName
      }
    }

    if (refFactorNo == '') {
      this.setState({
        refFactorNo: ''
      })
    } else {
      let dataDoc = {
        refFactorNo: this.state.refFactorNo
      }
    }

    // if (refFactorDate == '') {
    //     this.setState({
    //         refFactorDate: undefined
    //     })
    // } else {
    //     let dataDoc = {
    //         refFactorDate: refFactorDate
    //     }
    // }

    var submitForm = false
    var wareNameError = false
    var isinputError = false
    var doctypeError = false
    var refFacNO = false
    var quantityTableError = false

    $('.sahih').each(function() {
      if ($(this).val() < '1') {
        submitForm = true
        quantityTableError = true
        $(this).css('borderColor', '#f2682e')
        $(this).css('box-shadow', '0 0 0 0.2rem #fbd1c0')
      } else if (
        $(this)
          .val()
          .match(/\-?\d+\.\d+/g)
      ) {
        submitForm = true
        quantityTableError = true
        $(this).css('borderColor', '#f2682e')
        $(this).css('box-shadow', '0 0 0 0.2rem #fbd1c0')
        $('#errorCountText').html('واحد صحیح کالا مقدار اعشاری نمیپذیرد')
      } else if ($(this).val() <= '0') {
        submitForm = true
        quantityTableError = true
        $(this).css('borderColor', '#f2682e')
        $(this).css('box-shadow', '0 0 0 0.2rem #fbd1c0')
      } else if (
        $(this)
          .val()
          .match(/[a-z A-Z آ-ی]/g)
      ) {
        submitForm = true
        quantityTableError = true
        $(this).css('borderColor', '#f2682e')
        $(this).css('box-shadow', '0 0 0 0.2rem #fbd1c0')
      } else {
        $(this).css('borderColor', '#65e251')
        $(this).css('box-shadow', '0 0 0 0.2rem #cfedcb')
        if (!quantityTableError) {
          console.log('sd')
        }
      }
    })

    $('.ashar').each(function() {
      if ($(this).val() <= '0') {
        submitForm = true
        quantityTableError = true
        $(this).css('borderColor', '#f2682e')
        $(this).css('box-shadow', '0 0 0 0.2rem #fbd1c0')
      } else if (
        $(this)
          .val()
          .match(/[a-z A-Z آ-ی]/g)
      ) {
        submitForm = true
        quantityTableError = true
        $(this).css('borderColor', '#f2682e')
        $(this).css('box-shadow', '0 0 0 0.2rem #fbd1c0')
      } else {
        $(this).css('borderColor', '#65e251')
        $(this).css('box-shadow', '0 0 0 0.2rem #cfedcb')
        if (!quantityTableError) {
          console.log('sd')
        }
      }
    })

    let parcelId
    if (refType === 'CUSTOMER' && !this.state.isInternal) {
      parcelId = this.state.parcelId
    } else {
      parcelId = null
    }

    if (refType === 'CUSTOMER' && !this.state.isInternal && !parcelId) {
      message.error('شناسه مرسوله الزامی است')
      submitForm = true
    }

    if (refType === 'CUSTOMER' && boolIsInput && !refFactorNo) {
      message.error('شماره فاکتور الزامی است')
      submitForm = true
    }

    if (refType === 'CUSTOMER' && !boolIsInput && !refFactorNo && !this.state.isInternal) {
      message.error('شماره فاکتور الزامی است')
      submitForm = true
    }

    // if (refType === 'CUSTOMER' && !boolIsInput && !refFactorDate && !this.state.isInternal) {
    //     message.error('تاریخ فاکتور الزامی است')
    //     submitForm = true;
    // }

    // if (!(refFactorNo == '') && refFactorNo.match(/[a-z A-Z]/g)) {
    //     message.error('شماره فاکتور باید عدد صحیح باشد');
    //     submitForm = true;
    //     refFacNO = true;
    // } else {
    //     if (!refFacNO) {
    //         {
    //             console.log('sd')
    //         }
    //     }
    // }

    if (typeWarehouseId == '') {
      message.error('انبار را مشخص کنید')
      submitForm = true
      wareNameError = true
      this.setState({
        errorForm: {
          warehouseName: 'انبار را مشخص کنید'
        }
      })
    } else {
      if (!wareNameError) {
        this.setState({
          errorForm: {
            warehouseName: ''
          }
        })
      }
    }

    if (isInput == '') {
      message.error('ماهیت را مشخص کنید')

      isinputError = true
      submitForm = true
      this.setState({
        errorForm: {
          isInputError: 'ماهیت را مشخص کنید'
        }
      })
    } else {
      if (!isinputError) {
        this.setState({
          errorForm: {
            isInputError: ''
          }
        })
      }
    }

    if (typeDocId == '') {
      message.error('نوع سند را مشخص کنید')

      var doctypeError = true
      this.setState({
        errorForm: {
          warehouseTypeError: 'نوع سند را مشخص کنید'
        }
      })
    } else {
      if (!doctypeError) {
        this.setState({
          errorForm: {
            warehouseTypeError: ''
          }
        })
      }
    }
    if (isInternal) {
      if (refWarehouseId == '') {
        submitForm = true
        message.error('انبار طرف را مشخص کنید')
      } else {
        this.setState({
          errorDocForm: ''
        })

        var docData = {
          parcelId,
          refType: !refType || this.state.isInternal ? null : refType,
          typeWarehouseId: this.state.typeWarehouseId,
          isInput: boolIsInput,
          isInternal: this.state.isInternal,
          abnormal: this.state.abnormal,
          typeDocId: this.state.typeDocId,
          details: this.state.details,
          description: description == '' ? undefined : description,
          refWarehouseId: this.state.isInternal ? this.state.refWarehouseId : null,
          manualRegisterDate: manualRegisterDate == null ? undefined : this.epochFrom(manualRegisterDate),
          providerId,
          receiverId: this.state.receiverId == '' ? undefined : this.state.receiverId,
          senderId: this.state.senderId == '' ? undefined : this.state.senderId,
          senderName: this.state.senderName == '' ? undefined : this.state.senderName,
          receiverName: this.state.receiverName == '' ? undefined : this.state.receiverName,
          refFactorDate: !refFactorDate ? undefined : this.epochFrom(refFactorDate),
          refFactorNo: this.setValueRefFactorNumber(boolIsInput, refType, this.state.isInternal),
          checkIncompatible: false,
          otherSellers: this.state.otherSellers
        }
      }
    } else {
      this.setState({
        errorDocForm: ''
      })
      var docData = {
        parcelId,
        refType: !refType || this.state.isInternal ? null : refType,
        typeWarehouseId: this.state.typeWarehouseId,
        isInput: boolIsInput,
        isInternal: this.state.isInternal,
        abnormal: this.state.abnormal,
        typeDocId: this.state.typeDocId,
        details: this.state.details,
        description: description == '' ? undefined : description,
        manualRegisterDate: manualRegisterDate == null ? undefined : this.epochFrom(manualRegisterDate),
        providerId,
        receiverId: this.state.receiverId == '' ? undefined : this.state.receiverId,
        senderId: this.state.senderId == '' ? undefined : this.state.senderId,
        senderName: this.state.senderName == '' ? undefined : this.state.senderName,
        receiverName: this.state.receiverName == '' ? undefined : this.state.receiverName,
        refFactorDate: !refFactorDate ? undefined : this.epochFrom(refFactorDate),
        refFactorNo: this.setValueRefFactorNumber(boolIsInput, refType, this.state.isInternal),
        checkIncompatible: false,
        otherSellers: this.state.otherSellers
      }
    }

    if (!submitForm) {
      // alert(JSON.stringify(docData));
      this.setState({
        loading: true
      })
      http
        .post(`${WAREHOUSE.WAREHOUSE_DOCUEMNT_RECORD_PREVIEW}`, docData, {})
        .then((response) => {
          this.setState({
            loading: false
          })
          if (response.data.description != null) {
            message.error(response.data.description)
          } else {
            let successError = 'پیش سند با شماره ' + response.data.object.preDocId + ' ثبت شد.لطفا صبر کنید '
            message.success(successError)
            this.setState(
              {
                modalConfirm: false,
                modalError: false
              },
              () => {
                if (boolIsInput && !this.state.isInternal && this.state.anbarType === 3) {
                  let manualRegisterDate = this.convertDigit(document.getElementById('manualRegisterDate').value)
                  localStorage.setItem(
                    'clipText',
                    this.copyClipBoard(this.state.incompatibleSupplyOrderProducts, 'show')
                  )

                  let providerId = this.state.providerId
                  this.setState({
                    modalConfirm: false
                  })
                  window.open(
                    `/warehouse/link?showPrintLink=${false}&hasUnmatch=${true}&preRecordId=${
                      response.data.object.preDocId
                    }&providerId=${providerId}&date=${manualRegisterDate} `,
                    '_blank'
                  )
                  setTimeout(() => {
                    let data = {
                      typeWarehouseId: '',
                      checkIsInput: '',
                      typeDocId: '',
                      isInternal: false,
                      abnormal: false,
                      senderName: '',
                      receiverName: '',
                      refFactorNo: '',
                      description: '',
                      manualRegVal: moment(),
                      refFactor: null,
                      refWarehouseId: '',
                      providerId: '',
                      product: [],
                      details: [],
                      anbarTypeTaraf: '',
                      anbarType: '',
                      refType: '',
                      parcelId: ''
                    }
                    let urlParams = new URLSearchParams(window.location.search)
                    let preRecordId = urlParams.get('id') === null ? '' : urlParams.get('id')
                    localStorage.setItem('objectAddPreRecord' + preRecordId, JSON.stringify(data))
                    window.location.assign('/addPreRecord?id=' + preRecordId)
                  }, 3000)
                } else if (boolIsInput && !this.state.isInternal && this.state.anbarType === 6) {
                  let manualRegisterDate = this.convertDigit(document.getElementById('manualRegisterDate').value)
                  localStorage.setItem(
                    'clipText',
                    this.copyClipBoard(this.state.incompatibleSupplyOrderProducts, 'show')
                  )
                  let providerId = this.state.providerId
                  this.setState(
                    {
                      modalConfirm: false
                    },
                    () => {
                      window.open(
                        `/warehouse/link?showPrintLink=${true}&hasUnmatch=${true}&preRecordId=${
                          response.data.object.preDocId
                        }&providerId=${providerId}&date=${manualRegisterDate}&deliveryDates=${
                          this.state.deliveryDates
                        }`,
                        '_blank'
                      )
                      setTimeout(() => {
                        let data = {
                          typeWarehouseId: '',
                          checkIsInput: '',
                          typeDocId: '',
                          isInternal: false,
                          abnormal: false,
                          senderName: '',
                          receiverName: '',
                          refFactorNo: '',
                          description: '',
                          manualRegVal: moment(),
                          refFactor: null,
                          refWarehouseId: '',
                          providerId: '',
                          product: [],
                          details: [],
                          anbarTypeTaraf: '',
                          anbarType: '',
                          refType: '',
                          parcelId: ''
                        }
                        let urlParams = new URLSearchParams(window.location.search)
                        let preRecordId = urlParams.get('id') === null ? '' : urlParams.get('id')
                        localStorage.setItem('objectAddPreRecord' + preRecordId, JSON.stringify(data))
                        window.location.assign('/addPreRecord?id=' + preRecordId)
                      }, 3000)
                    }
                  )
                }
              }
            )

            this.setState({
              modalConfirm: false
            })
            setTimeout(() => {
              let data = {
                typeWarehouseId: '',
                checkIsInput: '',
                typeDocId: '',
                isInternal: false,
                abnormal: false,
                senderName: '',
                receiverName: '',
                refFactorNo: '',
                description: '',
                manualRegVal: moment(),
                refFactor: null,
                refWarehouseId: '',
                providerId: '',
                product: [],
                details: [],
                anbarTypeTaraf: '',
                anbarType: '',
                refType: '',
                parcelId: ''
              }
              let urlParams = new URLSearchParams(window.location.search)
              let preRecordId = urlParams.get('id') === null ? '' : urlParams.get('id')
              localStorage.setItem('objectAddPreRecord' + preRecordId, JSON.stringify(data))
              window.location.assign('/addPreRecord?id=' + preRecordId)
            }, 3000)
          }
        })
        .catch((error) => {
          this.setState({
            loading: false
          })
        })
    }
  }

  onChangeIsInput() {
    var isInput = document.getElementById('isInput').value
    let urlParams = new URLSearchParams(window.location.search)
    let preRecordId = urlParams.get('id') === null ? '' : urlParams.get('id')
    let ls = JSON.parse(localStorage.getItem('objectAddPreRecord' + preRecordId))
    if (isInput == 'true') {
      var boolInput = true
      ls['checkIsInput'] = boolInput
      localStorage.setItem('objectAddPreRecord' + preRecordId, JSON.stringify(ls))
      this.setState({
        checkIsInput: true
      })
    } else if (isInput == 'false') {
      var boolInput = false
      ls['checkIsInput'] = boolInput
      localStorage.setItem('objectAddPreRecord' + preRecordId, JSON.stringify(ls))
      this.setState({
        checkIsInput: false
      })
    }

    // var boolInput=isInput=='true'
    this.filterDocIds(boolInput)
  }

  filterDocIds = (boolInput) => {
    var filterWare = this.state.docArr

    http
      .get(`${WAREHOUSE.WAREHOUSE_TYPE_LIST_DOCUMENT}`, {})
      .then((response) => {
        if (response.data.errror == null) {
          this.setState({
            docType: response.data.object
          })

          filterWare = []
          this.state.docType.forEach(function(item) {
            if (boolInput == true) {
              if (item.in == true) {
                filterWare.push(item)
              }
            } else {
              if (item.out == true) {
                filterWare.push(item)
              }
            }
          })
          this.setState({
            docArr: filterWare
          })
        } else {
          message.error('خطای ' + response.data.errorCode + ' : ' + response.data.description)
        }
      })
      .catch((error) => {
        console.log(error)
      })
  }

  manualRegisterDate(props) {
    return <input className="form-control" {...props} />
  }

  refFactorDate(props) {
    return <input className="form-control" {...props} />
  }

  changeManual = (manualRegisterDate) => {
    this.setState({
      manualRegisterDate
    })
  }

  changeManufactorDate = (rowId, value) => {
    let target = rowId.target
    const object = {
      id: this.state.product[rowId].stockProductId,
      quantity: this.state.product[rowId].quantity,
      manufactureDate: ''
    }
    var index = this.state.details.findIndex((details) => details.id === object.id)

    const {details} = this.state
    const {product} = this.state
    this.setState(
      (prevState) => {
        const newDetails = details
        const newProduct = product
        newProduct[rowId].manufactureDate = value
        newDetails[index].manufactureDate = value
        return {
          product: newProduct,
          details: newDetails
        }
      },
      () => {
        let urlParams = new URLSearchParams(window.location.search)
        let preRecordId = urlParams.get('id') === null ? '' : urlParams.get('id')
        let ls = JSON.parse(localStorage.getItem('objectAddPreRecord' + preRecordId))
        ls['product'] = this.state.product
        ls['details'] = this.state.details
        localStorage.setItem('objectAddPreRecord' + preRecordId, JSON.stringify(ls))
      }
    )
  }

  setNowDateProduct = (rowId) => {
    let date = this.convertDigit(jMoment().format('jYYYY/jMM/jDD'))

    const object = {
      id: this.state.product[rowId].stockProductId,
      quantity: this.state.product[rowId].quantity
    }
    let index = this.state.details.findIndex((details) => details.id === object.id)
    const {details} = this.state
    const {product} = this.state
    this.setState(
      (prevState) => {
        const newDetails = details
        const newProduct = product
        newProduct[rowId].manufactureDate = date
        newDetails[index].manufactureDate = date
        return {
          product: newProduct,
          details: newDetails
        }
      },
      () => {
        let urlParams = new URLSearchParams(window.location.search)
        let preRecordId = urlParams.get('id') === null ? '' : urlParams.get('id')
        let ls = JSON.parse(localStorage.getItem('objectAddPreRecord' + preRecordId))
        ls['product'] = this.state.product
        ls['details'] = this.state.details
        localStorage.setItem('objectAddPreRecord' + preRecordId, JSON.stringify(ls))
      }
    )
    // alert(jMoment().format('jYYYY/jM/jD'))
  }

  shortKeyManufactorDate = (rowId, e) => {
    // alert(rowId)
    if (e.key === 'f' || e.key === 'F') {
      let date = this.convertDigit(jMoment().format('jYYYY/jMM/jDD'))

      const object = {
        id: this.state.product[rowId].stockProductId,
        quantity: this.state.product[rowId].quantity
      }
      let index = this.state.details.findIndex((details) => details.id === object.id)
      const {details} = this.state
      const {product} = this.state
      this.setState(
        (prevState) => {
          const newDetails = details
          const newProduct = product
          newProduct[rowId].manufactureDate = date
          newDetails[index].manufactureDate = date
          return {
            product: newProduct,
            details: newDetails
          }
        },
        () => {
          let urlParams = new URLSearchParams(window.location.search)
          let preRecordId = urlParams.get('id') === null ? '' : urlParams.get('id')

          let ls = JSON.parse(localStorage.getItem('objectAddPreRecord' + preRecordId))
          ls['product'] = this.state.product
          ls['details'] = this.state.details
          localStorage.setItem('objectAddPreRecord' + preRecordId, JSON.stringify(ls))
        }
      )
    } else {
      // message.error('برای تاریخ امروز دکمه f زده شود')
    }
    // e.key == 'Enter'
  }

  getValueProviderSearch = (providerIdSearch) => {
    this.setState({
      providerIdSearch
    })
  }

  copyClipBoard = (unmatch, error) => {
    let str = ''
    let title =
      ' ردیف ' +
      ' | ' +
      ' سفارش ' +
      ' | ' +
      '  ورود ' +
      ' | ' +
      '       کد کالا          ' +
      ' | ' +
      ' نام کالا ' +
      '\n'
    let dashe = '----------------------------------------------------------------------------------------' + '\n'
    let concat = title + dashe
    for (let i = 0; i < unmatch.length; i++) {
      let barcodeSpace = unmatch[i].barCode
      if (barcodeSpace.length < 13) {
        barcodeSpace = barcodeSpace.padStart(15)
      }
      str +=
        i +
        1 +
        '         |     ' +
        unmatch[i].remainQuantity +
        '        |    ' +
        unmatch[i].requestedQuantity +
        '     |  ' +
        barcodeSpace +
        '  | ' +
        unmatch[i].title +
        '\n'
      // str += 'تعداد سفارش : ' + unmatch[i].remainQuantity + ' ~ ' + ' تعداد ورود :‌ ' + unmatch[i].requestedQuantity + ' ~ ' + ' بارکد محصول‌ :  ' + unmatch[i].barCode + ' ~ ' + ' کد محصول : ' + unmatch[i].articleId + ' ~ ' + ' نام کالا :‌ ' + unmatch[i].title + '\n'
    }
    if (error === 'show') {
      message.success('در clipboard ذخیره شد')
    }

    return title + dashe + str
  }

  epochFrom1 = (x) => {
    var concatDayMount = x.split('/')
    var concatDate = concatDayMount[1] + concatDayMount[2]
    var constantDate = '0631'
    var n = concatDate.localeCompare(constantDate)

    let miladiDate = jMoment(x, 'jYYYY/jM/jD').format('YYYY/M/D')
    let from = miladiDate + ' ' + '00:00'
    let fromEpoch = moment.utc(from).valueOf()
    if (n >= 0) {
      return fromEpoch - 3.5 * 3600 * 1000
    } else if (n < 0 && concatDate === '0101') {
      return fromEpoch - 3.5 * 3600 * 1000
    } else {
      return fromEpoch - 3.5 * 3600 * 1000
    }
  }
  epochTo1 = (x) => {
    var concatDayMount = x.split('/')
    var concatDate = concatDayMount[1] + concatDayMount[2]
    var constantDate = '0631'
    var n = concatDate.localeCompare(constantDate)

    let miladiDate = jMoment(x, 'jYYYY/jM/jD').format('YYYY/M/D')
    let to = miladiDate + ' ' + '23:59:59'
    let toEpoch = moment.utc(to).valueOf()
    if (n >= 0) {
      return toEpoch - 3.5 * 3600 * 1000
    } else if (n < 0 && concatDate === '0101') {
      return toEpoch - 3.5 * 3600 * 1000
    } else {
      return toEpoch - 3.5 * 3600 * 1000
    }
  }

  getDriverOfProduct() {
    let manualRegisterDate = this.convertDigit(document.getElementById('manualRegisterDate').value)
    let providerId =
      this.state.providerId == null || this.state.providerId == '' ? '' : this.state.providerId.providerId
    let providerName = this.state.providerId == null || this.state.providerId == '' ? '' : this.state.providerId.title
    if (providerId === '') {
      message.error('تامین کننده باید انتخاب شده باشد')
    } else if (manualRegisterDate === '') {
      message.error('تاریخ دستی سند باید وارد شده باشد')
    } else {
      JASPERREPORT(
        `report/jasper/dispatch/driver/products/invoice?&providerId=${providerId}&providerName=${providerName}&fromTime=${this.epochFrom1(
          manualRegisterDate
        )}&toTime=${this.epochTo1(manualRegisterDate)}`
      )
        .then(() => {
          this.setState({loading: false})
        })
        .catch((err) => {
          this.setState({
            loading: false
          })
          message.error(err)
        })
    }
  }

  showInvoiceNumInvoiceDate = () => {
    let show = false
    let requiredInvoiceNum = false
    let requiredInvoiceDate = false
    if (!this.state.refType) {
      show = false
    }
    if (this.state.isInternal && this.state.anbarType == 5) {
      show = true
    } else if (!this.state.isInternal) {
      show = true
    }

    if (this.state.checkIsInput && this.state.refType === 'CUSTOMER') {
      requiredInvoiceNum = true
    } else if (!this.state.checkIsInput && this.state.refType === 'PROVIDER') {
      show = false
    } else if (!this.state.checkIsInput && this.state.refType === 'CUSTOMER') {
      requiredInvoiceNum = true
    }

    return {
      show,
      requiredInvoiceDate,
      requiredInvoiceNum
    }
  }

  render() {
    const {wareHousesname} = this.state

    const statusAnbarTaraf = this.state.isInternal == true ? false : true
    const valuerefWarehouseId = statusAnbarTaraf ? '' : this.state.refWarehouseId
    const barcodeStatus = this.state.valueBarcode == 'barcodeOnly' ? true : false
    const {fadeTable} = this.state
    const style = fadeTable == 'true' ? 'tableProductWarehouse hide' : 'tableProductWarehouse'
    const tableVisibile = this.state.searchTablevisibility ? 'block' : 'hide'
    const {pageNumber} = this.state
    const {manualRegVal, refFactor} = this.state
    const {selectedOption} = this.state

    let proId = this.state.providerId == null || this.state.providerId == '' ? '' : this.state.providerId.providerId

    return (
      <div>
        <Helmet>
          <meta charSet="utf-8" />
          <title>پیش سند جدید</title>
        </Helmet>
        {/*<AdminMenu/>*/}
        <div className="container-fluid">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>انبار</li>
            <li>ثبت پیش سند</li>
          </ul>
          <form onSubmit={this.submitForm.bind(this)} noValidate={true}>
            <div className="container-fluid my-2 p-2 bg-white">
              <div className="card">
                <div className="card-body p-3">
                  <div className="row">
                    <div className="col-12 col-md-4 my-2 col-lg-2">
                      <label htmlFor="wareType">
                        انبار
                        <span className="text-danger">*</span>
                      </label>
                      <Select
                        value={this.state.warehouseId}
                        onChange={this.changeWareHouseId}
                        options={this.state.wareHousesname}
                        placeholder="------"
                      />
                    </div>
                    <div className="col-12 col-md-4 my-2 col-lg-2">
                      <label htmlFor="ماهیت">
                        ماهیت
                        <span className="text-danger">*</span>
                      </label>
                      <select
                        className="custom-select"
                        disabled={this.state.typeWarehouseId == '' ? true : false}
                        onChange={this.onChangeIsInput.bind(this)}
                        name="isInput"
                        id="isInput"
                        tabIndex="2"
                      >
                        <option value="">ماهیت را تعیین کنید</option>
                        <option
                          selected={this.state.checkIsInput === true ? true : false}
                          value={true}
                          disabled={this.state.isInternal ? true : false}
                        >
                          وارده
                        </option>
                        <option selected={this.state.checkIsInput === false ? true : false} value={false}>
                          صادره
                        </option>
                      </select>
                    </div>

                    {!this.state.isInternal && (
                      <div className="col-12 col-md-4 my-2 col-lg-2">
                        <label>
                          نوع طرف
                          {!this.state.isInternal && <span className="text-danger">*</span>}
                        </label>
                        <select
                          className="custom-select"
                          disabled={this.state.typeWarehouseId == '' ? true : false}
                          onChange={this.changeField.bind(this)}
                          name="refType"
                          id="refType"
                        >
                          <option value="">-----</option>
                          <option selected={this.state.refType === 'CUSTOMER' ? true : false} value={'CUSTOMER'}>
                            مشتری
                          </option>
                          <option selected={this.state.refType === 'PROVIDER' ? true : false} value={'PROVIDER'}>
                            فروشنده
                          </option>
                        </select>
                      </div>
                    )}

                    {!this.state.isInternal && this.state.refType === 'CUSTOMER' && (
                      <div className="col-12 col-md-4 my-2 col-lg-2">
                        <ParcelSearch
                          label="شناسه مرسوله"
                          required
                          setParcel={(parcelId) => this.setState({parcelId})}
                          value={this.state.parcelId}
                        />
                      </div>
                    )

                    // <div className='col-12 col-md-4 my-2 col-lg-2'>
                    //     <label>شناسه مرسوله
                    //         <span className="text-danger">*</span>
                    //     </label>
                    //     <input type="number" defaultValue={this.state.parcelId} onChange={this.changeField.bind(this)}
                    //     name="parcelId" className="form-control"/>
                    // </div>
                    }

                    <div className="col-12 col-md-4 my-2 col-lg-2">
                      <label htmlFor="docType">
                        نوع سند
                        <span className="text-danger">*</span>
                      </label>
                      <select
                        id="docType"
                        name="typeDocId"
                        disabled={this.state.typeWarehouseId == '' ? true : false}
                        tabIndex="3"
                        className="custom-select"
                        onChange={this.changeField.bind(this)}
                      >
                        <option value="">نوع سند را مشخص کنید</option>
                        {this.state.docArr.map((docs, index) => (
                          <option
                            selected={+this.state.typeDocId === +docs.id ? true : false}
                            key={index}
                            value={docs.id}
                          >
                            {docs.name}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="col-12 col-md-4 my-2 col-lg-2 d-flex flex-column align-content-center justify-content-center">
                      <label className="hiddenLabel">sd</label>
                      <Checkbox
                        name="isInternal"
                        tabIndex="4"
                        disabled={this.state.checkIsInput || this.state.typeWarehouseId == '' ? true : false}
                        checked={this.state.isInternal}
                        onChange={this.changeField.bind(this)}
                      >
                        سند بین انبار
                      </Checkbox>
                    </div>
                    <div className="col-12 col-md-4 my-2 col-lg-2 d-flex flex-column align-content-center justify-content-center">
                      <label className="hiddenLabel">sd</label>
                      <Checkbox
                        name="abnormal"
                        tabIndex="4"
                        checked={this.state.abnormal}
                        disabled={this.state.typeWarehouseId == '' ? true : false}
                        onChange={this.changeField.bind(this)}
                      >
                        سند اصلاحی
                      </Checkbox>
                    </div>
                    <div className="col-12 col-md-4 my-2 col-lg-2 d-flex flex-column align-content-center justify-content-center">
                      <label className="hiddenLabel">sd</label>
                      <Checkbox
                        name="otherSellers"
                        tabIndex="4"
                        checked={this.state.otherSellers}
                        disabled={this.state.typeWarehouseId == '' ? true : false}
                        onChange={this.changeField.bind(this)}
                      >
                        خرید متفرقه
                      </Checkbox>
                    </div>
                    <div className="col-12 col-md-4 my-2 col-lg-2">
                      <label>تحویل دهنده</label>
                      <input
                        type="text"
                        disabled={this.state.typeWarehouseId == '' ? true : false}
                        defaultValue={this.state.senderName}
                        onChange={this.optionalFields.bind(this)}
                        tabIndex="5"
                        name="senderName"
                        className="form-control"
                      />
                    </div>
                    <div className="col-12 col-md-4 my-2 col-lg-2">
                      <label>تحویل گیرنده</label>
                      <input
                        type="text"
                        disabled={this.state.typeWarehouseId == '' ? true : false}
                        defaultValue={this.state.receiverName}
                        onChange={this.optionalFields.bind(this)}
                        tabIndex="6"
                        name="receiverName"
                        className="form-control"
                      />
                    </div>
                    <div className="col-12 col-md-4 my-2 col-lg-2">
                      <label>تاریخ دستی سند </label>
                      <MuiPickersUtilsProvider utils={JalaliUtils} locale="fa">
                        <DatePicker
                          okLabel="تأیید"
                          autoOk={true}
                          leftArrowIcon={<Icon type="left" />}
                          rightArrowIcon={<Icon type="right" />}
                          cancelLabel="لغو"
                          labelFunc={(manualRegVal) =>
                            manualRegVal == null ? '' : manualRegVal.format('jYYYY/jMM/jDD')
                          }
                          value={manualRegVal}
                          onChange={this.handleDateChangeManual}
                          onKeyPress={this.preventType}
                          TextFieldComponent={this.manualRegisterDate}
                          tabIndex="7"
                          disabled={this.state.typeWarehouseId == '' ? true : false}
                          id="manualRegisterDate"
                          name="manualRegisterDate"
                          readOnly
                        />
                      </MuiPickersUtilsProvider>
                    </div>

                    {!this.state.isInternal && !this.state.init && (
                      <div className="col-12 col-md-4 my-2 col-lg-2">
                        <AutoComplete
                          label="طرف تامین کننده"
                          api={`${REPORT_RETAIL.REPORT_RETAIL_LIST_PROVIDER}`}
                          textField="title"
                          valueField="providerId"
                          id="provider"
                          extraFilter={{typeWarehouseId: this.state.typeWarehouseId, id: this.state.providerId}}
                          disabled={
                            this.state.refType === 'CUSTOMER' || this.state.typeWarehouseId == '' ? true : false
                          }
                          value={this.state.providerId}
                          setValue={this.getValueProvider}
                        />
                      </div>
                    )}

                    <div className="col-12 col-md-4 my-2 col-lg-2">
                      <label htmlFor="ماهیت">
                        انبار طرف
                        {this.state.isInternal ? <span className="text-danger">*</span> : null}
                      </label>
                      <Select
                        isDisabled={statusAnbarTaraf || this.state.typeWarehouseId == '' ? true : false}
                        value={this.state.typeRefWarehouseId}
                        onChange={this.changeTypeWareHouseId}
                        options={this.state.wareHousesname}
                        isClearable
                        placeholder="------"
                      />
                    </div>

                    {this.showInvoiceNumInvoiceDate().show && (
                      <div className="col-12 col-md-4 my-2 col-lg-2">
                        <label>
                          شماره فاکتور
                          {this.showInvoiceNumInvoiceDate().requiredInvoiceNum && (
                            <span className="text-danger">*</span>
                          )}
                        </label>
                        <input
                          type="text"
                          disabled={this.state.typeWarehouseId == '' ? true : false}
                          defaultValue={this.state.refFactorNo}
                          onChange={this.optionalFields.bind(this)}
                          tabIndex="10"
                          name="refFactorNo"
                          className="form-control"
                        />
                      </div>
                    )}

                    {this.showInvoiceNumInvoiceDate().show && (
                      <div className="col-12 col-md-4 my-2 col-lg-2">
                        <label>
                          تاریخ فاکتور طرف
                          {this.showInvoiceNumInvoiceDate().requiredInvoiceDate && (
                            <span className="text-danger">*</span>
                          )}
                        </label>
                        <MuiPickersUtilsProvider utils={JalaliUtils} locale="fa">
                          <DatePicker
                            okLabel="تأیید"
                            autoOk={true}
                            leftArrowIcon={<Icon type="left" />}
                            rightArrowIcon={<Icon type="right" />}
                            cancelLabel="لغو"
                            labelFunc={(refFactor) => (refFactor == null ? '' : refFactor.format('jYYYY/jMM/jDD'))}
                            onKeyPress={this.preventType}
                            onChange={this.handleDaterefFactor}
                            TextFieldComponent={this.refFactorDate}
                            value={refFactor}
                            disabled={this.state.typeWarehouseId == '' ? true : false}
                            id="refFactorDate"
                            tabIndex="11"
                            name="refFactorDate"
                            readOnly
                          />
                        </MuiPickersUtilsProvider>
                      </div>
                    )}

                    <div className="col-12 my-2">
                      <div className="w-100">
                        <lable>توضیحات</lable>
                        <input
                          type="text"
                          className="form-control"
                          style={{height: '40px', marginTop: '5px'}}
                          id="description"
                          name="description"
                          defaultValue={this.state.description}
                          disabled={this.state.typeWarehouseId == '' ? true : false}
                          onChange={this.optionalFields.bind(this)}
                          tabIndex="12"
                        />
                      </div>
                    </div>
                  </div>
                  <hr className="my-3" />
                  <div className="row">
                    <div className="col-12 col-md-8 col-lg-9">
                      <div className="row">
                        <div className="col-12 col-md-auto d-flex flex-row justify-content-start align-item-center align-content-center">
                          <RadioGroup
                            className="text-left d-flex flex-row pt-4 pb-0"
                            disabled={this.state.typeWarehouseId == '' ? true : false}
                            onChange={this.onChangeRadio}
                            value={this.state.valueBarcode}
                          >
                            <Radio value="barcodeOnly">بارکد</Radio>
                            <Radio value="barcodeCount">بارکد و تعداد</Radio>
                          </RadioGroup>
                        </div>
                        <div className="col-12 col-md-auto text-left">
                          <label>بارکد</label>
                          <input
                            type="text"
                            disabled={this.state.typeWarehouseId == '' ? true : false}
                            autoComplete="off"
                            id="id"
                            ref={(node) => (this.barcode = node)}
                            maxLength="18"
                            tabIndex="14"
                            className="form-control"
                            onClick={() => this.barcode.select()}
                            onKeyPress={this.barcodeChange.bind(this)}
                            name="code"
                          />
                        </div>
                        <div className="col-12 col-md-auto text-left">
                          <label>تعداد</label>
                          <input
                            type="text"
                            id="quantity"
                            ref={(node, event) => (this.quantity = node)}
                            className="form-control"
                            name="quantity"
                            onClick={() => this.quantity.select()}
                            onChange={this.changeQuantity.bind(this)}
                            tabIndex="15"
                            disabled={barcodeStatus || this.state.typeWarehouseId == '' ? true : false}
                          />
                        </div>
                        <div className="col-12 col-md-auto d-flex flex-column align-content-end justify-content-end">
                          <button
                            className="my-0 form-control btn btn-primary btn-sm"
                            disabled={this.state.typeWarehouseId == '' ? true : false}
                            onClick={this.addProduct.bind(this)}
                            size="sm"
                          >
                            افزودن به لیست
                          </button>
                        </div>
                        <div className="col-12 col-md-auto d-flex flex-column align-content-end justify-content-end">
                          <button
                            className="my-0 form-control btn btn-warning btn-sm"
                            disabled={barcodeStatus || this.state.typeWarehouseId == '' ? true : false}
                            onClick={this.openModal}
                            size="sm"
                          >
                            جست و جوی کالا
                          </button>
                        </div>
                        <div className="col-auto d-flex flex-column align-item-end align-content-end justify-content-end">
                          <p className="errorText mb-0">{this.state.addError}</p>
                        </div>
                      </div>
                    </div>
                    <div className="col-12 col-md-4  col-lg-3">
                      {this.state.showLastProduct && (
                        <div className={this.state.addProduct ? 'alert alert-success' : 'alert alert-danger'}>
                          <strong>
                            {!this.state.addProduct ? 'مشخصات آخرین کالای حذف شده' : 'مشخصات آخرین کالای وارد شده'}
                          </strong>
                          <hr />
                          <p className="mb-0">{'بارکد ‌: ' + this.state.lastEnteredProduct.barcode}</p>
                          <p className="mb-0">{'نام : ' + this.state.lastEnteredProduct.name}</p>
                          <p className="mb-0">
                            {'مقدار : ' +
                              this.state.lastEnteredProduct.count +
                              ' ' +
                              this.state.lastEnteredProduct.unit}
                          </p>
                          <p className="mb-0">{'ساعت : ' + this.state.lastEnteredProduct.time}</p>
                        </div>
                      )}
                    </div>
                  </div>

                  {this.state.product.length > 0 && (
                    <div>
                      <table className="baseTable mt-4" style={{width: '100%'}}>
                        <tbody>
                          <tr className="firstRow">
                            <td>ردیف</td>
                            <td>تامین کننده</td>
                            <td>کد محصول</td>
                            <td>بارکد محصول</td>
                            <td>نام محصول</td>
                            <td>مقدار</td>
                            <td>واحد</td>
                            <td>تاریخ تولید</td>
                            <td>حذف</td>
                          </tr>
                          {this.state.product.map((items, index) => (
                            <tr key={index}>
                              <td>{this.state.product.length - index}</td>
                              <td>{items.providerName}</td>
                              <td>{items.articleId}</td>
                              <td>{items.productCode}</td>
                              <td>
                                <a target="_blank" href={productShop({articleId: items.articleId})}>
                                  {items.productName}
                                </a>
                              </td>
                              <td>
                                {/*{items.quantity}*/}
                                <input
                                  autoComplete="off"
                                  className={'countText' + ' ' + 'tableQuantity' + ' ' + items.vahed}
                                  value={items.quantity}
                                  // defaultValue={items.quantity}
                                  type="text"
                                  min="1"
                                  onChange={(e) => this.changeCount(index, e.target.value)}
                                  name="quantity"
                                  id={index}
                                />
                              </td>
                              <td>{items.productUnitTitle}</td>
                              <td className="d-flex flex-row justify-content-between">
                                <button
                                  onClick={() => this.setNowDateProduct(index)}
                                  className="btn btn-sm btn-success"
                                >
                                  تاریخ امروز
                                </button>
                                <InputMask
                                  autocomplete="off"
                                  placeholder="yyyy/mm/dd"
                                  className="form-control"
                                  style={{width: '80%', display: 'block', margin: 'auto'}}
                                  mask="9999/99/99"
                                  maskChar={null}
                                  // ref={(node)=>this.manufactorDate = node}
                                  defaultValue={items.manufactureDate}
                                  value={items.manufactureDate}
                                  onKeyPress={(e) => this.shortKeyManufactorDate(index, e)}
                                  onChange={(e) => this.changeManufactorDate(index, e.target.value)}
                                />
                                {/*<input type={'text'} onChange={(e)=>this.changeManufactorDate(index,e.target.value)} value={items.manufactureDate}/>*/}
                              </td>
                              <td>
                                <button key={index} onClick={() => this.delete(index)}>
                                  <img src={require('../../image/trash.svg')} alt="" />
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                      <Button
                        className="position-sticky mx-0 mt-4"
                        style={{bottom: 10}}
                        onClick={this.getDocId.bind(this)}
                      >
                        ثبت پیش سند
                      </Button>
                      <span id="errorCountText" className="errorText" />
                    </div>
                  )}
                </div>
              </div>
            </div>
          </form>

          <Modal isOpen={this.state.modalConfirm} toggle={this.cancelConfirm.bind(this)} size="sm">
            <ModalHeader toggle={this.cancelConfirm.bind(this)}>تاییدیه</ModalHeader>
            <Loader show={this.state.loading} />
            <ModalBody>
              <p className="titleSm">آیا از ثبت پیش سند مطمئن هستید؟؟</p>
            </ModalBody>
            <ModalFooter>
              <button className="confirmBtnModal" onClick={this.setPreRecord.bind(this)}>
                ثبت پیش سند
              </button>
              <button className="cancelBtnModal" onClick={this.cancelConfirm.bind(this)}>
                لغو
              </button>
            </ModalFooter>
          </Modal>
          <Modal isOpen={this.state.modal} toggle={this.toggle} size="lg">
            <ModalHeader toggle={this.toggle}>محصول خود را جست و جو کنید</ModalHeader>
            <ModalBody>
              <form className="modalForm searchProduct" onSubmit={this.submitForm.bind(this)}>
                <figure>
                  <label>نام محصول : </label>
                  <input
                    className="form-control"
                    ref={(node) => (this.productName = node)}
                    type="text"
                    id="productName"
                    placeholder="نام محصول را وارد کنید"
                  />
                </figure>
                <figure>
                  {this.state.showProviderModal && (
                    <AutoComplete
                      label="تامین کننده"
                      api={`${REPORT_RETAIL.REPORT_RETAIL_LIST_PROVIDER}`}
                      textField="title"
                      valueField="providerId"
                      id="provider"
                      value={this.state.providerIdSearch}
                      setValue={(providerIdSearch) => this.setState({providerIdSearch})}
                    />
                  )}

                  {/* <label>طرف - تامین کننده</label>
                                    <Select
                                        value={this.state.providerIdSearch}
                                        onChange={this.getValueProviderSearch}
                                        options={this.state.providers}
                                        isClearable
                                        placeholder='------'
                                        
                                    /> */}
                </figure>

                <figure>
                  <label>بارکد محصول:</label>
                  <input className="form-control" type="text" id="productCode" placeholder="بارکد محصول را وارد کنید" />
                </figure>

                <figure>
                  <label>کد محصول:</label>
                  <input className="form-control" type="text" id="articleCode" placeholder="کد محصول را وارد کنید" />
                </figure>

                <figure>
                  <label className="hiddenLabel">نام تامین کننده:</label>
                  <button
                    onClick={this.searchProduct.bind(this)}
                    className="searchProduct form-control btn btn-primary btn-sm mb-5"
                  >
                    جست و جو
                  </button>
                  <p className="errorText" />
                </figure>
              </form>
              <div className={tableVisibile}>
                <div className="tableComponent">
                  <table className="baseTable searchProductTable">
                    <tbody>
                      <tr className="firstRow">
                        <td>انتخاب</td>
                        <td>ردیف</td>
                        <td>نام محصول</td>
                        <td>کد محصول</td>
                        <td>تامین کننده</td>
                        <td>بارکد</td>
                        <td>واحد</td>
                      </tr>
                      {this.state.searchesProduct.map((product, index) => (
                        <tr key={index} onDoubleClick={() => this.double(index)}>
                          <td>
                            <RadioGroup onChange={this.onchangeSearch.bind(this)} value={this.state.search}>
                              <Radio value={index} />
                            </RadioGroup>
                          </td>
                          <td>{(pageNumber - 1) * 7 + index + 1}</td>

                          <td>
                            <a target="_blank" href={productShop({articleId: product.articleId})}>
                              {product.productName}
                            </a>
                          </td>
                          <td>{product.articleId}</td>
                          <td>{product.providerName}</td>
                          <td>{product.productCode}</td>
                          <td>{product.productUnitTitle}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  <div className="paginationWrapp">
                    <Pagination
                      defaultCurrent={this.state.pageNumber}
                      total={this.state.lengthProducts}
                      onChange={this.onChangePagination.bind(this)}
                    />
                  </div>
                </div>
              </div>
            </ModalBody>
            <ModalFooter>
              <button className="confirmBtnModal" onClick={this.handleOk}>
                تایید
              </button>
              <button className="cancelBtnModal" onClick={this.handleCancel}>
                لغو
              </button>
            </ModalFooter>
          </Modal>

          <Modal isOpen={this.state.modalError} toggle={this.cancelError.bind(this)}>
            <ModalHeader toggle={this.cancelError.bind(this)}>لیست مغایرت ها</ModalHeader>
            <Loader show={this.state.loading} />
            <ModalBody>
              <p className="titleSm">{this.state.textUnMatch}</p>

              {this.state.deliveryDates.length > 0 && (
                <>
                  <p>تاریخ‌(های) تحویل مشتری</p>
                  <table className="baseTable mb-3">
                    <tbody>
                      <tr className="firstRow">
                        <td>ردیف</td>
                        <td>تاریخ</td>
                      </tr>
                      {this.state.deliveryDates.map((date, index) => (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{jMoment(date).format('jYYYY/jMM/jDD')}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </>
              )}
              <div
                className="unMatchClass"
                style={this.state.incompatibleRemainProducts.length == '0' ? {display: 'none'} : {display: 'block'}}
              >
                <p>لیست مغایرت موجودی انبار</p>
                <table className="baseTable">
                  <tbody>
                    <tr className="firstRow">
                      <td>ردیف</td>
                      <td>نام محصول</td>
                      <td>کد محصول</td>
                      <td>{this.state.checkIsInput ? 'تعداد ورود' : 'تعداد در سند'}</td>
                      <td>تعداد موجودی</td>
                    </tr>
                    {this.state.incompatibleRemainProducts.map((product, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>
                          <a target="_blank" href={productShop({articleId: product.articleId})}>
                            {product.title}
                          </a>
                        </td>
                        <td>{product.articleId}</td>
                        <td style={{fontSize: '1.2em'}} className="font-weight-bolder">
                          {product.requestedQuantity}
                        </td>
                        <td style={{fontSize: '1.2em'}} className="font-weight-bolder">
                          {product.remainQuantity}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              <div
                className="unMatchClass"
                style={
                  this.state.incompatibleSupplyOrderProducts.length == '0' ? {display: 'none'} : {display: 'block'}
                }
              >
                <p>لیست مغایرت موجودی سفارش تامین کننده</p>
                <table className="baseTable">
                  <tbody>
                    <tr className="firstRow">
                      <td>ردیف</td>
                      <td>نام محصول</td>
                      <td>کد محصول</td>
                      <td>{this.state.checkIsInput ? 'تعداد ورود' : 'تعداد در سند'}</td>
                      <td>تعداد سفارش</td>
                    </tr>
                    {this.state.incompatibleSupplyOrderProducts.map((product, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>
                          <a target="_blank" href={productShop({articleId: product.articleId})}>
                            {product.title}
                          </a>
                        </td>
                        <td>{product.articleId}</td>
                        <td style={{fontSize: '1.2em'}} className="font-weight-bolder">
                          {product.requestedQuantity}
                        </td>
                        <td style={{fontSize: '1.2em'}} className="font-weight-bolder">
                          {product.remainQuantity}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                {this.state.showClipboardBtn && (
                  <CopyToClipboard
                    text={this.copyClipBoard(this.state.incompatibleSupplyOrderProducts, 'notShow')}
                    onCopy={() => this.copyClipBoard(this.state.incompatibleSupplyOrderProducts, 'show')}
                  >
                    <span
                      className="my-4 text-white p-2 d-inline-block rounded"
                      style={{background: '#f7941e', cursor: 'pointer'}}
                    >
                      کپی در clipBoard
                    </span>
                  </CopyToClipboard>
                )}
              </div>

              <div
                className="unMatchClass"
                style={this.state.incompatibleDispatchProducts.length == '0' ? {display: 'none'} : {display: 'block'}}
              >
                <p>لیست مغایرت کالا های توزیع</p>
                <table className="baseTable">
                  <tbody>
                    <tr className="firstRow">
                      <td>ردیف</td>
                      <td>نام محصول</td>
                      <td>کد محصول</td>
                      <td>{this.state.checkIsInput ? 'تعداد ورود' : 'تعداد در سند'}</td>
                      <td>تعداد توزیع</td>
                    </tr>
                    {this.state.incompatibleDispatchProducts.map((product, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>
                          <a target="_blank" href={productShop({articleId: product.articleId})}>
                            {product.title}
                          </a>
                        </td>
                        <td>{product.articleId}</td>
                        <td style={{fontSize: '1.2em'}} className="font-weight-bolder">
                          {product.requestedQuantity}
                        </td>
                        <td style={{fontSize: '1.2em'}} className="font-weight-bolder">
                          {product.remainQuantity}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              <div style={this.state.tableNotFound ? {display: 'block'} : {display: 'none'}}>
                <table className="baseTable">
                  <tbody>
                    <tr className="firstRow">
                      <td>ردیف</td>
                      <td>نام محصول</td>
                      <td>کد محصول</td>
                      <td>بارکد محصول</td>
                    </tr>
                    {this.state.unMatchProduct.map((product, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>
                          <a target="_blank" href={productShop({articleId: product.articleId})}>
                            {product.title}
                          </a>
                        </td>
                        <td>{product.articleId}</td>
                        <td>{product.barCode}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </ModalBody>
            <ModalFooter>
              <button
                className="confirmBtnModal"
                style={this.state.tableNotFound ? {display: 'none'} : {display: 'block'}}
                onClick={this.setFinalyPreRecord.bind(this)}
              >
                ثبت پیش سند
              </button>
              <button className="cancelBtnModal" onClick={this.cancelError.bind(this)}>
                لغو
              </button>
            </ModalFooter>
          </Modal>

          <Modal isOpen={this.state.modalShowLinks} toggle={() => this.setState({modalShowLinks: false})} size="sm">
            <ModalBody>
              <div className="d-flex flex-column justify-content-center align-item-center align-content-center">
                {/*hasUnmatch = false ? show print link */}
                <h4 className="font-weight-bold">
                  {this.state.hasUnmatch === false && (
                    <a
                      className="btn btn-lg btn-info btn-block"
                      href={'/ShowPreRecord/' + this.state.preRecordId}
                      target="_blank"
                    >
                      مشاهده و چاپ
                    </a>
                  )}
                </h4>
                <h4 className="font-weight-bold">
                  <a
                    className="btn btn-lg btn-success btn-block"
                    href={`/orderList?providerId=${this.state.queryProvider}&hasUnmatch=${this.state.hasUnmatch}&date=${
                      this.state.date
                    }`}
                    target="_blank"
                  >
                    گزارش وضعیت سفارشات
                  </a>
                </h4>
                <button className="btn btn-info btn-block jasperBtn" onClick={this.getDriverOfProduct.bind(this)}>
                  {' '}
                  گزارش کالای رساننده به تفکیک فاکتور
                </button>
              </div>
              <p className="errorText" id="errorText" />
            </ModalBody>
            <ModalFooter>
              <button className="cancelBtnModal" onClick={() => this.setState({modalShowLinks: false})}>
                بستن
              </button>
            </ModalFooter>
          </Modal>
        </div>
      </div>
    )
  }
}

export default AddPreRecord
